'use client';

import { analytics } from 'lib/analytics/analytics';
import {
  BoxOutline,
  CaretUp,
  Checkmark,
  ChevronRight,
  CircleTick,
  HandWithRing,
  InfoIcon,
  ShippingBox,
  ShoppingTrolley,
  // ArrowTopRight,
  WarningTriangle,
} from 'assets/icons';
import { PrimaryButton } from 'components/shared/PrimaryButton';
import {
  DeliveryEtaBadge,
  SddDeliverySlot,
  SddHeroEstimate,
} from 'components/ring-air/DeliveryEtaBadge';
import { AeDeliveryEtaCard } from 'components/ring-air/AeDeliveryEta/index';
import {
  aeDeliveryEtaCopy,
  aeDeliveryEtaShortCopy,
} from 'components/ring-air/AeDeliveryEta/copy';
import { useAeDeliveryEta } from 'components/ring-air/AeDeliveryEta/useAeDeliveryEta';
import {
  sddCheckoutEta,
  sddHeroTimeline,
  sddReplacesWarehouseEstimate,
} from 'components/ring-air/DeliveryEtaBadge/useSddNddEligibility';
import {
  RING_BUY_GTM_EVENTS,
  sizeLabel,
  trackRingBuyOption,
  uhxPlanOf,
} from 'components/ring-air/analytics/ringBuyEvents';
import { trackEvent } from 'components/shared/UserAnalytics/funnelEvents';
import {
  AE_DELIVERY_ETA_ENABLED,
  SDD_NDD_BADGE_ENABLED,
} from 'utils/featureFlags';
import {
  getB1DiscountedEmiBasePrice,
  getIndiaEmiMonthLabel,
  withIndiaEmiOfferPrice,
} from 'components/ring-air/utils/offersByRegion';
import { useTranslations } from 'next-intl';
import BirthdayIcon from '../../../assets/birthday-icon.svg';
// import { DeliveryManagement } from 'components/m1/DeliveryManagement';
import { isMarketingBannerActive } from 'components/shared/Header/MarketingBanner';
import { TravelChargerPricingModal } from 'components/shared/InfoModals/TravelChargerModal';
import { UhxPricingModal } from 'components/shared/InfoModals/uhx';
import {
  OffersModalNewContext,
  OffersModalNewProvider,
} from 'components/shared/OffersModal';
// import { PlantTreesBanner } from 'components/shared/PlantTreesBanner';
import { VitaminAngelsBanner } from 'components/shared/VitaminAngelsBanner';
import { usePathname, useSearchParams } from 'next/navigation';
import { useRegionLocale } from 'contexts/RegionLocaleContext';
import {
  forwardRef,
  Fragment,
  ReactNode,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { AfibShopifyMap, hasAfibVariants } from 'content/products/addons/afib';
import { CardioAdaptibilityShopifyMap } from 'content/products/addons/cardioAdaptibility';
import { ClueShopifyMap, isClueAvailable } from 'content/products/addons/clue';
import { CnoProShopifyMap } from 'content/products/addons/cnoPro';
import { RespiratoryShopifyMap } from 'content/products/addons/respiratory';
import {
  AfibCountryCodes,
  AirRingColors,
  DEFAULT_PRICE_STRIKED_STORES,
  EngravingPrice,
  // DarkMoonChargerShopifyMap,
  getEngravingKey,
  getRingAirColorNameImages,
  getRingAirColorTag,
  getAvailableAirRingColors,
  productMap_air_ring,
  RingChargerType,
  RingPriceData,
  RingSizes,
} from 'content/products/ring';

import { CircledArrow } from 'assets/icons/CircledArrow';
import { ClueLogo } from 'assets/icons/ClueLogo';
import { UhxIcon } from 'assets/icons/UhxIcon';
import { HeroCategoriesMap } from 'components/shared/Cart/utils';
import CustomLink from 'components/shared/CustomLink';
import { AfibPricingModal } from 'components/shared/InfoModals/Afib';
import { CardioAdaptabilityPricingModal } from 'components/shared/InfoModals/CardioAdaptability';
import { CluePricingModal } from 'components/shared/InfoModals/Clue';
import { CnoProPricingModal } from 'components/shared/InfoModals/CnoPro';
import { TradeInModal } from 'components/shared/InfoModals/TradeIn';
import Image from 'next/image';
import { Currency } from 'utils/Currency';
import { getTravelChargerPrice } from 'content/products/accessories';
import { RingAirCarouselData } from 'content/products/ring/productCarouselImages';
import {
  applyBlingDiscount,
  getBlingDiscountPercentage,
  isBlingVisible as isBlingVisibleForStore,
  isGoldHaloSoldOut,
  isStackSizeUnavailable,
  RingStackType,
} from 'content/products/ring/stacking/constants';
import {
  DuoStackingShopifyMap,
  StackingShopifyMap,
} from 'content/products/ring/stacking/StackingShopifyMap';
import {
  getMaxTradeInCredit,
  isTradeInAvailable,
  TRADE_IN_DEVICE_NAMES,
  UHX_BONUS,
} from 'content/products/tradeIn';
import { UhxShopifyMap } from 'content/products/uhx';
import { GlobalUIContext } from 'contexts/GlobalUIContext';
import {
  CurrencySymbol,
  useFormatPrice,
  getCurrencySymbolFromString,
} from 'hooks/pricing/useFormattedPrice';
import useIsCnOPlus from 'hooks/pricing/useIsCnOPlus';
import { getInstallmentConfig } from 'utils/installmentConfig';
import { useWindowSize } from 'hooks/dom/useWindowSize';
import {
  getEffectiveStoreForDiscount,
  ShopifyStore,
} from 'lib/commerce/shopify/shopifyHelper';
import {
  CustomImage,
  DotSpinner,
  FSAHSAComponent,
  getShippingAndTaxDisclaimerMap,
  useModal,
  PHONE_MAX_WIDTH_IN_PX,
} from '../..';
import styles from './index.module.css';

const cx = (...classes: (string | undefined)[]) =>
  classes.filter(Boolean).join(' ');
import { useCartStore, useShallow } from 'components/shared/Cart';
import { RespiratoryLogo } from '../../../assets/icons/RespiratoryLogo';
import { RespiratoryPricingModal } from '../../shared/InfoModals/Respiratory';
import { useRetouchFlowContext } from '../../shared/RetouchFlow';
import { OffersCarousel, OffersDataType } from '../OffersCarousel';
import { RingSelectionContext } from '../RingSelectionContext';
import { SecondaryOfferDataType } from '../SecondaryOfferComponent';
import { H2 } from '../styleConstants';
import { ImageModal } from './ImageModal';
import { RingSizeGuideModal } from './RingSizeGuideModal';
import { OtherProductSection } from './OtherProductsSection';
import { PrimaryOffersModalData } from './PrimaryOffers';
import { RingAirProductCarousel } from './RingAirProductCarousel';
import {
  StackingImagesModalContent,
  StackingSelectionContent,
} from './StackingSection';

export const PanelContainer = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={`u-grid${className ? ` ${className}` : ''}`} {...props} />
);

export const LeftPanel = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cx(styles.leftPanel, className)} {...props} />
);

// Mobile-only product carousel slot. Rendered at all breakpoints so the SSR
// markup is correct without a JS width gate, and hidden on desktop via CSS
// (where the LeftPanel carousel takes over). Replaces the old
// `width < PHONE_MAX && ...` gate that caused the hero to pop in after hydration.
const MobileCarouselSection = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cx(styles.mobileCarouselSection, className)} {...props} />
);

export const RightPanel = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cx(styles.rightPanel, className)} {...props} />
);

type ProductSectionId =
  | 'uhx'
  | 'color-picker'
  | 'size-select'
  | 'bling-stacking'
  | 'charger-select'
  | 'trade-in'
  | 'engraving'
  | 'clue-addon'
  | 'power-plugs'
  | 'order-overview';

const DEFAULT_SECTION_ORDER: ProductSectionId[] = [
  'color-picker',
  'size-select',
  'bling-stacking',
  'charger-select',
  'trade-in',
  'engraving',
  'clue-addon',
  'power-plugs',
  'uhx',
  'order-overview',
];

// Main Export Here 👇🏻
export const ProductSelectionSection = ({
  className,
  title,
  buySectionTitle,
  description,
  emiCopies,
  secondaryOfferData,
  offersData,
  defaultStrikedPrice,
  defaultOfferText,
  defaultOfferDiscount,
  bgColor,
}: // offersBackgroundColor,
// dealsBackgroundColor,
{
  className?: string;
  title?: string;
  buySectionTitle?: string;
  description?: string;
  emiCopies?: boolean;
  secondaryOfferData?: SecondaryOfferDataType[];
  offersData?: OffersDataType[];
  defaultStrikedPrice?: boolean;
  defaultOfferText?: string;
  defaultOfferDiscount?: string | number;
  bgColor?: string;
  offersBackgroundColor?: string;
  dealsBackgroundColor?: string;
}) => {
  const { width: _width } = useWindowSize();
  const globalUI = useContext(GlobalUIContext);
  const { color, notServicable } = useContext(RingSelectionContext);
  const tCommon = useTranslations('common');
  void title;

  return (
    <section
      className={cx(styles.root, 'u-grid', className)}
      data-banner={isMarketingBannerActive() ? 'true' : 'false'}
      style={{ backgroundColor: bgColor ? bgColor : 'transparent' }}
    >
      <OffersModalNewProvider>
        <div className="content">
          {notServicable ? (
            <OtherProductSection
              title={tCommon(
                'productSelectionSection.otherProductSection.title.ringAirIsn',
              )}
              subtitle={tCommon(
                'productSelectionSection.otherProductSection.subtitle',
              )}
            />
          ) : null}
          {/* {!notServicable &&
              offersData &&
              ((width as number) > PHONE_MAX_WIDTH_IN_PX ? (
                <PrimaryOffers
                  data={offersData}
                  $backgroundColor={offersBackgroundColor}
                  $dealsBackgroundColor={dealsBackgroundColor}
                />
              ) : (
                <PrimaryOffersTransitionTile
                  data={offersData}
                  backgroundColor={offersBackgroundColor}
                  dealsBackgroundColor={dealsBackgroundColor}
                />
              ))} */}
          <PanelContainer
            style={{ filter: notServicable ? 'grayscale(1)' : undefined }}
          >
            <LeftPanel>
              <StickyPanel $headerVisible={globalUI?.headerVisible ?? true}>
                <div>
                  <RingAirProductCarousel
                    selectedColor={color as AirRingColors}
                    items={
                      (color
                        ? RingAirCarouselData[color]
                        : RingAirCarouselData[AirRingColors.RAW_TITANIUM]) ?? []
                    }
                    sticky={true}
                    footerItems={[
                      {
                        title: (
                          <>
                            {tCommon(
                              'productSelectionSection.ringAirProductCarousel.tryItRisk',
                            )}
                          </>
                        ),
                      },
                    ]}
                  />
                </div>
              </StickyPanel>
            </LeftPanel>
            <RightPanel>
              <BuySection
                buySectionTitle={buySectionTitle}
                description={description}
                emiCopies={emiCopies}
                secondaryOfferData={secondaryOfferData}
                offersData={offersData}
                defaultStrikedPrice={defaultStrikedPrice}
                defaultOfferText={defaultOfferText}
                defaultOfferDiscount={defaultOfferDiscount}
              />
            </RightPanel>
          </PanelContainer>
        </div>
      </OffersModalNewProvider>
    </section>
  );
};

const StickyPanel = ({
  $headerVisible,
  children,
  ...props
}: {
  $headerVisible: boolean;
} & React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={styles.stickyPanel}
    data-header-visible={$headerVisible ? 'true' : 'false'}
    {...props}
  >
    {children}
  </div>
);

const SizeInfoModal = ({ className }: { className?: string }) => {
  const t = useTranslations('ring');
  const tCommon = useTranslations('common');
  const { width } = useWindowSize();
  return (
    <div className={cx(styles.sizeInfoModal, className)}>
      {/* <h2>How Ring Sizing Works</h2> */}
      <h2>{t('ring.productSelection.sizingSection.modalNew.title')}</h2>
      <p>
        {tCommon('productSelectionSection.text.ultrahumanRingAir')}
        {/* {t('ring.productSelection.sizingSection.modalNew.subtitle')} */}
      </p>
      <ol>
        <li>
          <ShoppingTrolley />
          <h5>
            {/* <span>Step 1:</span> Order your ring */}
            <span>
              {t('ring.productSelection.sizingSection.modalNew.stepA.step')}
            </span>{' '}
            {t('ring.productSelection.sizingSection.modalNew.stepA.title')}
          </h5>
          <p>
            {/* Place your order for the ring. A complimentary sizing kit is
            automatically included with every purchase unless you specifically
            opt out of it. */}
            {t('ring.productSelection.sizingSection.modalNew.stepA.subTitle')}
          </p>
        </li>
        <li>
          <BoxOutline fill="#000000" />
          <h5>
            {/* <span>Step 2:</span> Await the free ring sizing kit delivery */}
            <span>
              {t('ring.productSelection.sizingSection.modalNew.stepB.step')}
            </span>{' '}
            {t('ring.productSelection.sizingSection.modalNew.stepB.title')}
          </h5>
          <p>
            {/* We expedite your sizing kit, ensuring it&apos;s shipped within 24
            hours after you place your order. The kit contains a range of sample
            rings to help determine your ideal fit. This kit is yours to keep
            and share. */}
            {t('ring.productSelection.sizingSection.modalNew.stepB.subTitle')}
          </p>
        </li>
        <li>
          <HandWithRing />
          <h5>
            {/* <span>Step 3:</span> Find your perfect ring size */}
            <span>
              {t('ring.productSelection.sizingSection.modalNew.stepC.step')}
            </span>{' '}
            {t('ring.productSelection.sizingSection.modalNew.stepC.title')}
          </h5>
          <p>
            {/* Use the sample rings to identify your most comfortable size. For
            optimal results, watch the video guide or read the step-by-step
            guide{' '} */}
            {t('ring.productSelection.sizingSection.modalNew.stepC.subTitle')}{' '}
            <CustomLink
              target={'_blank'}
              href="/sizing"
              style={{ textDecoration: 'underline' }}
              onClick={() =>
                trackRingBuyOption(RING_BUY_GTM_EVENTS.SIZE_GUIDE_LINK, {
                  target: 'sizing_page',
                })
              }
            >
              {/* here */}
              {t(
                'ring.productSelection.sizingSection.modalNew.stepC.HERE',
              )}{' '}
            </CustomLink>
            . {/* Take time to ensure the best fit. */}
            {t('ring.productSelection.sizingSection.modalNew.stepC.endText')}
          </p>
        </li>
        <li>
          <CircleTick />
          <h5>
            {/* <span>Step 4:</span> Submit your ring size */}
            <span>
              {t('ring.productSelection.sizingSection.modalNew.stepD.step')}
            </span>{' '}
            {t('ring.productSelection.sizingSection.modalNew.stepD.title')}
          </h5>
          <p>
            {/* After confirming your ideal size, submit it through the Ultrahuman
            app or via the order tracking link. We&apos;ll then process your
            order and ship your ring. */}
            {t('ring.productSelection.sizingSection.modalNew.stepD.subTitle')}
          </p>
        </li>
      </ol>
      <CustomLink
        className="video"
        target="_blank"
        href="https://www.youtube.com/watch?v=t9ca-Lq70q4"
        onClick={() =>
          trackRingBuyOption(RING_BUY_GTM_EVENTS.SIZE_GUIDE_LINK, {
            target: 'youtube',
          })
        }
      >
        <CustomImage
          width={540}
          height={270}
          alt={tCommon(
            'productSelectionSection.customImage.alt.sizingKitVideo',
          )}
          src={
            width < 900
              ? 'web_v2/ring-buy/thumbnail_desktop.png'
              : 'web_v2/ring-buy/thumbnail_mobile.png'
          }
        />
        {tCommon('productSelectionSection.link.watchOurVideo')}
      </CustomLink>
      <hr />

      <p className="disclaimer">
        {/* The right fit ensures both comfort for continuous wear and accurate data
        tracking. If you need any assistance, our team is here to help at every
        step. Reach out to us at{' '} */}
        {t('ring.productSelection.sizingSection.modalNew.disclaimer')}{' '}
        <a
          href="mailto:support@ultrahuman.com"
          onClick={() =>
            trackRingBuyOption(RING_BUY_GTM_EVENTS.SIZE_GUIDE_LINK, {
              target: 'email',
            })
          }
        >
          support@ultrahuman.com
        </a>
        .
      </p>
    </div>
  );
};

const LearnMoreButton = ({
  className,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement>) => {
  const tCommon = useTranslations('common');
  return (
    <button className={cx(styles.learnMoreButton, className)} {...props}>
      {props.children ??
        tCommon('productSelectionSection.learnMoreButton.learnMore')}
      <CircledArrow />
    </button>
  );
};

const Section = forwardRef<
  HTMLDivElement,
  {
    className?: string;
    title?: React.ReactNode | string;
    subTitle?: React.ReactNode | string;
    subText?: React.ReactNode | string;
    openInfoModal?: () => void;
    openInfoModalText?: React.ReactNode | string;
    children: React.ReactNode;
    childClass: string;
    sectionClass?: string;
    show: boolean;
    disableScrollToScreen?: boolean;
    hsaFsaBadge?: boolean;
  }
>(
  (
    {
      className,
      title,
      subTitle,
      subText,
      openInfoModal,
      openInfoModalText,
      children,
      childClass,
      sectionClass,
      show,
      hsaFsaBadge,
    },
    ref,
  ) => {
    return (
      <div
        ref={ref}
        className={cx(
          styles.section,
          className,
          show ? 'show' : '',
          sectionClass,
        )}
        data-has-modal-text={openInfoModalText ? 'true' : 'false'}
      >
        {title ? (
          <div className="section-row-title">
            <h5>
              {title} <span className="subtitle">{subTitle}</span>
            </h5>
            {openInfoModal ? (
              <button onClick={openInfoModal}>
                {!openInfoModalText ? (
                  <InfoIcon
                    style={{
                      width: '1.6rem',
                      height: 'auto',
                      marginTop: '1px', //change this when changing the font sizes
                    }}
                    fill="#000"
                  />
                ) : null}
                {openInfoModalText ? openInfoModalText : null}
              </button>
            ) : null}
          </div>
        ) : null}
        {subText ? <p className="section-row-sub-title">{subText}</p> : null}
        {hsaFsaBadge ? (
          <div className="hsa-fsa-badge">
            <FSAHSAComponent />
          </div>
        ) : null}
        <div className={`section-row-content ${childClass}`}>{children}</div>
      </div>
    );
  },
);

Section.displayName = 'Section';

const Separator = ({
  transparent,
  size = 'lg',
  ...props
}: {
  transparent?: boolean;
  size?: 'sm' | 'md' | 'lg' | 'xl';
} & React.HTMLAttributes<HTMLHRElement>) => {
  const sizeMap = { sm: '16px', md: '24px', lg: '32px', xl: '48px' };
  return (
    <hr
      className={styles.separator}
      style={{
        width: '100%',
        margin: `${sizeMap[size]} 0`,
        background: transparent ? 'none' : 'initial',
        border: transparent ? 'none' : '0.5px solid rgba(0, 0, 0, 0.1)',
      }}
      {...props}
    />
  );
};

const PowerPlugSubsection = ({
  title,
  description,
  image,
  children,
  className,
}: {
  title: string;
  description?: string;
  image?: string;
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className={cx(styles.powerPlugSubsection, className)}>
      <div className="subsection-header">
        {image ? (
          <div className="image-container">
            <CustomImage src={image} alt={title} height="64" width="64" />
          </div>
        ) : null}
        <div className="text-container">
          <h4 className="subsection-title">{title}</h4>
          {description ? (
            <p className="subsection-description">{description}</p>
          ) : null}
        </div>
      </div>
      <div className="ultrahumanx-content">{children}</div>
    </div>
  );
};

const LargePromptBtnStyledContent = ({
  className,
  children,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement>) => (
  <button className={cx(styles.largePrompt, className)} {...props}>
    {children}
  </button>
);

const BuySection = ({
  className,
  emiCopies,
  secondaryOfferData,
  offersData,
  description,
  buySectionTitle = 'Ring AIR',
  defaultStrikedPrice = false,
  defaultOfferText,
  defaultOfferDiscount,
}: {
  className?: string;
  emiCopies?: boolean;
  description?: string;
  buySectionTitle?: string;
  secondaryOfferData?: SecondaryOfferDataType[];
  offersData?: OffersDataType[];
  defaultStrikedPrice?: boolean;
  defaultOfferText?: string;
  defaultOfferDiscount?: number | string;
}) => {
  const { region: country } = useRegionLocale();
  // AE window-rule ETA gate: deliberately the URL region, NOT the Shopify
  // store — QA/BH/KW/OM share ShopifyStore.AE and must not see the promise.
  const isAeRegion = country?.toUpperCase() === 'AE';
  const isAeDeliveryVisible = isAeRegion && AE_DELIVERY_ETA_ENABLED;
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const RingSelectionClient = useContext(RingSelectionContext);
  const { store, getCampaignForProduct } = useCartStore(
    useShallow((s) => ({
      store: s.store,
      getCampaignForProduct: s.getCampaignForProduct,
    })),
  );
  const isBlingVisible = useMemo(
    () =>
      !RingSelectionClient.isLeanBuyFlow &&
      isBlingVisibleForStore(country, store as ShopifyStore | undefined),
    [country, store, RingSelectionClient.isLeanBuyFlow],
  );
  const { resetCounter: resetRetouchCounter } = useRetouchFlowContext();
  const ringCampaign = getCampaignForProduct('ring');
  const { width } = useWindowSize();
  const ModalClient = useModal();
  const {
    color,
    setColor,

    size,
    setSize,

    chargerType,

    uhx,

    uhxCart,
    setUhxCart,

    defaultCurrency: currency,

    engraving,

    setEngraving,

    engravingMessage,

    setEngravingMessage,

    showEngravingSection,

    checkout,
    isLoading,
    price,
    effectivePrice,
    currencySymbol,
    ultraHumanPrice,
    chargerPrice,
    shippingEstimate,
    sddNdd,
    affiliateDetails,
    affiliateDiscount,
    referral,
    setChargerType,
    sectionRefs,
    effectiveDiscount,
    afibCart,
    setAfibCart,
    cardioAdaptibilityCart,
    setCardioAdaptabilityCart,
    cnoProCart,
    setCnoProCart,
    clueCart,
    setClueCart,
    respiratoryCart,
    setRespiratoryCart,
    stackType,
    setStackType,
    stackVariant,
    setStackVariant,
    priceDrop,
    notServicable,
    notServicableMessage,
    isOpenSizeDisabled,
    tradeInMaxCredit,
    tradeInDevice,
    setTradeInDevice,
    tradeInSerialNumber,
    setTradeInSerialNumber,
    tradeInCredit,
  } = RingSelectionClient;

  const replaceWarehouse = sddReplacesWarehouseEstimate(sddNdd.state);
  const checkoutEta = sddCheckoutEta(sddNdd.state);
  const heroTimeline = sddHeroTimeline(sddNdd.state);

  // AE window-rule ETA: once the region matches, the window copy is the only
  // ETA on every surface — the backend shipping-estimate line is hidden on
  // AE for now. Ineligible emirates resolve to the flat next-day promise
  // inside aeDeliveryEtaCopy.
  const aeEta = useAeDeliveryEta(isAeDeliveryVisible);

  if (!defaultStrikedPrice) {
    defaultStrikedPrice = DEFAULT_PRICE_STRIKED_STORES.includes(
      store as ShopifyStore,
    );
  }

  const effectiveStoreForAffiliate = getEffectiveStoreForDiscount(store);

  const OfferModalNewClient = useContext(OffersModalNewContext);

  const installmentConfig = getInstallmentConfig(
    store as ShopifyStore | undefined,
  );
  const installmentPrice = installmentConfig
    ? Math.ceil((price - effectiveDiscount.amount) / installmentConfig.months)
    : null;

  const airIndiaEmiBasePrice = useMemo(() => {
    if (store !== ShopifyStore.IN) return 0;
    const b1Base =
      RingPriceData[ShopifyStore.IN][AirRingColors.RAW_TITANIUM]?.price ?? 0;
    return getB1DiscountedEmiBasePrice(
      b1Base,
      price,
      effectiveDiscount.amount ?? 0,
    );
  }, [store, price, effectiveDiscount.amount]);

  const handlePaymentOptions = () => {
    if (!resolvedOffersData || resolvedOffersData.length === 0) return;
    OfferModalNewClient.set(
      <ImageModal>
        <PrimaryOffersModalData data={resolvedOffersData} />
      </ImageModal>,
    );
    OfferModalNewClient.show();
  };

  const {
    showSizeRef,
    showChargerRef,
    showTradeInRef,
    engravingRef,
    coverageRef,
    powerplugRef,
    cartSummaryRef,
  } = sectionRefs;

  const isAfibOrCardio: 'afib' | 'cardio' =
    country &&
    AfibCountryCodes.includes(country) &&
    hasAfibVariants(store as ShopifyStore)
      ? 'afib'
      : 'cardio';

  const isClueFlow =
    searchParams?.get('flow') === 'clue' &&
    isClueAvailable(store as ShopifyStore);
  // DISABLED: hardcoded AE copy ("Save 25% on Ring AIR + 3 Months Free
  // Cycle & Ovulation Plus"). Forced off. Re-enable with:
  // isRingAirPromoBannerVisible(country) && !!ringCampaign
  const showRingAirPromoBanner = false;
  // DISABLED: Respiratory Health flow — forced off. Re-enable by restoring original expression.
  // const isRespiratoryFlow = router.query.flow === 'respiratory';
  const isRespiratoryFlow = false;
  const showRespiratoryAddon = false;
  const { getValue } = useIsCnOPlus();
  const isOvusenseFlow = searchParams?.get('affiliateCode') === 'ovusense';
  const showTradeIn =
    isTradeInAvailable(
      store as ShopifyStore,
      searchParams?.get('affiliateCode'),
    ) && tradeInMaxCredit > 0;

  // Determine ring promo text based on country
  // const ringPromoText =
  //   (router.query.locale as string)?.toUpperCase() === 'AU' ||
  //   country?.toUpperCase() === 'AU'
  //     ? 'Black Friday Offer Applied'
  //     : 'Special Offer Applied';

  //FOR HSA/FSA redirects
  useEffect(() => {
    const scrollTimeout = setTimeout(() => {
      if (
        powerplugRef?.current &&
        searchParams?.get('ps') === 'cardio-powerplug' &&
        store === ShopifyStore.US
      ) {
        powerplugRef.current.scrollIntoView({
          behavior: 'smooth',
        });
      }
    }, 100);

    return () => {
      if (scrollTimeout) clearTimeout(scrollTimeout);
    };
  }, []);

  const openSizeInfoModal = () => {
    trackEvent('ringSizeGuideOpen');
    ModalClient.set(
      country === ShopifyStore.CA ? <RingSizeGuideModal /> : <SizeInfoModal />,
    );
    ModalClient.setPortal(true);
    ModalClient.show();
  };

  const openUhxInfoModal = () => {
    trackRingBuyOption(RING_BUY_GTM_EVENTS.UHX_INFO_OPEN, {
      uhxPlan: uhxPlanOf(uhxCart),
    });
    ModalClient.set(<UhxPricingModal />);
    ModalClient.setPortal(true);
    ModalClient.show();
  };

  const openVoyagerCharger = () => {
    ModalClient.set(<TravelChargerPricingModal />);
    ModalClient.setPortal(true);
    ModalClient.show();
  };

  const openCnoPro = () => {
    ModalClient.set(<CnoProPricingModal />);
    ModalClient.setPortal(true);
    ModalClient.show();
  };

  const openAfibModal = () => {
    ModalClient.set(<AfibPricingModal />);
    ModalClient.setPortal(true);
    ModalClient.show();
  };

  const openCardioModal = () => {
    ModalClient.set(<CardioAdaptabilityPricingModal />);
    ModalClient.setPortal(true);
    ModalClient.show();
  };

  const openClueModal = () => {
    ModalClient.set(<CluePricingModal />);
    ModalClient.setPortal(true);
    ModalClient.show();
  };

  const openRespiratoryModal = () => {
    ModalClient.set(<RespiratoryPricingModal />);
    ModalClient.setPortal(true);
    ModalClient.show();
  };
  const [isTradeInModalVisible, setIsTradeInModalVisible] = useState(false);
  const openTradeInModal = (
    source: 'section' | 'price_line' | 'deep_link' = 'section',
  ) => {
    trackRingBuyOption(RING_BUY_GTM_EVENTS.TRADE_IN_OPEN, {
      source,
      hadDevice: Boolean(tradeInDevice),
    });
    setIsTradeInModalVisible(true);
  };
  const removeTradeIn = (source: 'section' | 'price_line') => {
    trackRingBuyOption(RING_BUY_GTM_EVENTS.TRADE_IN_REMOVED, {
      source,
      hadDevice: Boolean(tradeInDevice),
    });
    setTradeInDevice(null);
    setTradeInSerialNumber('');
  };

  // Impression of the trade-in UHX bonus banner, once per page view.
  const uhxBonusTrackedRef = useRef(false);
  const uhxBonusAmount = UHX_BONUS[store as ShopifyStore] ?? 0;
  useEffect(() => {
    if (uhxBonusTrackedRef.current || !showTradeIn || !size || !uhxBonusAmount)
      return;
    uhxBonusTrackedRef.current = true;
    trackRingBuyOption(RING_BUY_GTM_EVENTS.UHX_BONUS_SHOWN, {
      bonus: uhxBonusAmount,
    });
  }, [showTradeIn, size, uhxBonusAmount]);

  // Deep link from marketing pages (/why-ultrahuman -> /ring/buy?tradeIn=1).
  // The param is stripped via history.replaceState, not router.replace: main
  // uses `shallow: true`, and in the App Router only a raw history write is
  // equally shallow (router.replace would refetch the RSC payload).
  useEffect(() => {
    if (!store) return;
    const flag = searchParams?.get('tradeIn');
    if (flag !== '1' && flag !== 'true') return;

    if (showTradeIn) {
      trackRingBuyOption(RING_BUY_GTM_EVENTS.TRADE_IN_OPEN, {
        source: 'deep_link',
        hadDevice: false,
      });
      setIsTradeInModalVisible(true);
    }

    const rest = new URLSearchParams(searchParams?.toString() ?? '');
    rest.delete('tradeIn');
    const qs = rest.toString();
    window.history.replaceState(
      window.history.state,
      '',
      qs ? `${pathname}?${qs}` : pathname,
    );
  }, [searchParams, pathname, store, showTradeIn]);

  const handleCheckout = () => {
    if (isLoading) return;
    analytics.track(`CLICK: Product Selection, Add to Cart`);
    resetRetouchCounter(); // Reset retouch flow counter on Add to Cart
    checkout('summary');
    ModalClient.hide();
  };

  const [manualSizeSelectVisible, setManualSizeSelectVisible] = useState(
    isOpenSizeDisabled === true ? true : false,
  );

  const sizeContainerAccordionRef = useRef<HTMLDivElement>(null);
  const sizeContainerRef = useRef<HTMLDivElement>(null);

  const handleManualSizeSelectShow = () => {
    trackRingBuyOption(RING_BUY_GTM_EVENTS.SIZE_MANUAL_TOGGLE, {
      expanded: isOpenSizeDisabled ? true : !manualSizeSelectVisible,
    });
    if (isOpenSizeDisabled) {
      setManualSizeSelectVisible(true);
      return;
    }
    setManualSizeSelectVisible((prev) => !prev);
  };

  const t = useTranslations('ring');

  const resolvedOffersData = useMemo(
    () =>
      store === ShopifyStore.IN
        ? (withIndiaEmiOfferPrice(offersData, t, airIndiaEmiBasePrice) ??
          offersData)
        : offersData,
    [store, offersData, t, airIndiaEmiBasePrice],
  );
  const tCart = useTranslations('cart');
  const tCommon = useTranslations('common');
  const RingAirColorNameImages = getRingAirColorNameImages(t);
  const isCnoProActive = true;

  // this is used to scoll from powerplugs
  // const element = document.getElementById('powerplugs');
  // const scrolledRef = useRef<boolean>(false);
  // useEffect(() => {
  //   if (
  //     router.asPath.includes('#cardio') &&
  //     !scrolledRef.current &&
  //     element
  //   ) {
  //     coverageRef?.current?.scrollIntoView({ behavior: 'smooth' });
  //     scrolledRef.current = true;
  //   }
  // }, [router, element]);

  const sizeDisclaimerViewedRef = useRef<boolean>(false);

  const handleSizeDisclaimer = () => {
    if (sizeDisclaimerViewedRef.current || isOpenSizeDisabled) return;

    ModalClient.setCloseBtnHidden(true);
    ModalClient.set(
      <div
        style={{
          padding: '24px',
          maxWidth: '500px',
          width: '100%',
        }}
      >
        <h2
          style={{
            fontWeight: '500',
            fontSize: '24px',
            letterSpacing: '-0.3px',
          }}
        >
          <WarningTriangle
            fill="#F2B534"
            style={{
              height: '17px',
              width: 'auto',
              marginRight: '8px',
            }}
          />
          {/* Our ring sizes are unique */}
          {t('ring.productSelection.sizeDisclaimerNew.title')}
        </h2>
        <p
          style={{
            fontSize: '19px',
            marginTop: '16px',
            lineHeight: '130%',
            color: 'rgba(0,0,0,0.75)',
            maxWidth: '100%',
            letterSpacing: '-0.3px',
          }}
        >
          {/* Ultrahuman Rings have custom sizes, different from standard smart
            rings. The right fit ensures accurate data tracking. */}
          {t('ring.productSelection.sizeDisclaimerNew.content.a')}
          <br />
          <br />
          {/* If you know your size, proceed confidently. If not, get a free
            sizing kit (shipped within 24 hours) for the perfect fit. Guessing
            wrong costs the planet. */}
          {t('ring.productSelection.sizeDisclaimerNew.content.b')}
        </p>
        <div className={styles.disclaimerButtonContainer}>
          <button
            className={styles.disclaimerButton}
            onClick={() => {
              setSize(RingSizes.OPEN);
              ModalClient.hide();
              ModalClient.set(null);
              setManualSizeSelectVisible(false);
            }}
          >
            {/* Get free sizing kit */}
            {t('ring.productSelection.sizeDisclaimerNew.btnTextA')}
          </button>

          <button
            onClick={() => {
              sizeDisclaimerViewedRef.current = true;
              ModalClient.hide();
              ModalClient.set(null);
              analytics.track(`CLICK: Manual size selection`, {
                size: size ?? null,
              });
            }}
            className={cx(styles.disclaimerButton, 'secondary gtm')}
            data-buttontype="Manual Size Selection Agree"
            data-product="Manual Size Selection Agree"
          >
            {/* I know my size */}
            {t('ring.productSelection.sizeDisclaimerNew.btnTextB')}
          </button>
        </div>
      </div>,
    );
    ModalClient.show();
  };

  const memoizedSizeContainerHeight = useMemo(() => {
    if (!sizeContainerAccordionRef.current || !sizeContainerRef.current)
      return '0px';
    if (!manualSizeSelectVisible) {
      return '0px';
    } else {
      return sizeContainerRef.current.scrollHeight + 24 + 'px';
    }
  }, [manualSizeSelectVisible, isOpenSizeDisabled]);

  useEffect(() => {
    if (!sizeContainerAccordionRef.current) return;
    sizeContainerAccordionRef.current.style.height =
      memoizedSizeContainerHeight;
  }, [memoizedSizeContainerHeight]);

  useEffect(() => {
    if (searchParams?.get('affiliate') || searchParams?.get('affiliateCode')) {
      setUhxCart(null);
    }
  }, [searchParams]);

  useEffect(() => {
    if (!isBlingVisible && stackType && stackType !== RingStackType.NONE) {
      setStackType(RingStackType.NONE);
    }
  }, [isBlingVisible]);

  const soldOutStacks = useMemo(() => {
    const stacks = [RingStackType.SILVER_HALO, RingStackType.GOLD_HALO].filter(
      (stack) =>
        (stack === RingStackType.GOLD_HALO &&
          isGoldHaloSoldOut(store as ShopifyStore | undefined)) ||
        isStackSizeUnavailable(stack, size),
    );
    return stacks.length ? stacks : undefined;
  }, [store, size]);

  useEffect(() => {
    if (stackType && soldOutStacks?.includes(stackType)) {
      setStackType(RingStackType.NONE);
    }
  }, [soldOutStacks, stackType]);

  const stackingOriginalPrices = useMemo(() => {
    if (!store) return {};
    const storeMap = StackingShopifyMap[store];
    return {
      [RingStackType.SILVER_HALO]:
        storeMap?.[RingStackType.SILVER_HALO]?.price ?? 0,
      [RingStackType.GOLD_HALO]:
        storeMap?.[RingStackType.GOLD_HALO]?.price ?? 0,
    };
  }, [store]);

  const duoStackingOriginalPrices = useMemo(() => {
    if (!store) return {};
    const duoStoreMap = DuoStackingShopifyMap[store];
    return {
      [RingStackType.SILVER_HALO]:
        duoStoreMap?.[RingStackType.SILVER_HALO]?.price ?? 0,
      [RingStackType.GOLD_HALO]:
        duoStoreMap?.[RingStackType.GOLD_HALO]?.price ?? 0,
    };
  }, [store]);

  const stackingPrices = useMemo(() => {
    return {
      [RingStackType.SILVER_HALO]: applyBlingDiscount(
        stackingOriginalPrices[RingStackType.SILVER_HALO] ?? 0,
        store,
      ),
      [RingStackType.GOLD_HALO]: applyBlingDiscount(
        stackingOriginalPrices[RingStackType.GOLD_HALO] ?? 0,
        store,
      ),
    };
  }, [stackingOriginalPrices, store]);

  const duoStackingPrices = useMemo(() => {
    return {
      [RingStackType.SILVER_HALO]: applyBlingDiscount(
        duoStackingOriginalPrices[RingStackType.SILVER_HALO] ?? 0,
        store,
      ),
      [RingStackType.GOLD_HALO]: applyBlingDiscount(
        duoStackingOriginalPrices[RingStackType.GOLD_HALO] ?? 0,
        store,
      ),
    };
  }, [duoStackingOriginalPrices, store]);
  const formatPriceWithComma = useFormatPrice();

  const heroCategoryOfferTagMap = {
    [HeroCategoriesMap.ATHLETES]: (
      <>
        <CustomImage
          width={24}
          height={24}
          alt="athlete-icon"
          src={'web_v2/hero/hero-icons-green/Athlete.svg'}
        />{' '}
        {tCommon('productSelectionSection.content.athleteSavingsApplied')}
      </>
    ),
    [HeroCategoriesMap.SCIENTIST]: (
      <>
        <CustomImage
          width={24}
          height={24}
          alt="science-icon"
          src={'web_v2/hero/hero-icons-green/Science.svg'}
        />{' '}
        {tCommon('productSelectionSection.content.scienceSavingsApplied')}
      </>
    ),
    [HeroCategoriesMap.HEALTHCARE]: (
      <>
        <CustomImage
          width={24}
          height={24}
          alt="healthcare-icon"
          src={'web_v2/hero/hero-icons-green/Healthcare.svg'}
        />{' '}
        {tCommon('productSelectionSection.content.healthcareSavingsApplied')}
      </>
    ),
    [HeroCategoriesMap.EDUCATION]: (
      <>
        <CustomImage
          width={24}
          height={24}
          alt="university-icon"
          src={'web_v2/hero/hero-icons-green/University.svg'}
        />
        {tCommon('productSelectionSection.content.educationSavingsApplied')}
      </>
    ),
    [HeroCategoriesMap.VETERANS]: (
      <>
        <CustomImage
          width={28}
          height={28}
          alt="veteran-icon"
          src={'web_v2/hero/hero-icons-green/Veteran.svg'}
        />{' '}
        {tCommon('productSelectionSection.content.militarySavingsApplied')}
      </>
    ),
  };

  // const ColorSelectionChip = styled.div`
  //   display: flex;
  //   align-items: center;
  //   gap: 8px;
  //   padding: 8px 16px;
  //   // background: #f5f5f5;
  //   font-size: 14px;
  //   border-radius: 12px;
  //   color: rgba(0, 0, 0, 0.5);
  //   margin-top: 8px;

  //   strong {
  //     font-weight: 500;
  //     color: black;
  //   }
  // `;

  const ringPriceForSelection =
    store && color ? RingPriceData[store]?.[color] : undefined;
  const engravingStrikePrice =
    engraving && store ? (EngravingPrice[store as ShopifyStore] ?? 0) : 0;
  const strikeBasePrice =
    (ringPriceForSelection?.striked_price ??
      ringPriceForSelection?.price ??
      0) + engravingStrikePrice;

  const NotServicableMessage = notServicable ? (
    notServicableMessage ? (
      <div className={styles.notServicableMessageContainer}>
        <WarningTriangle
          fill={'rgba(0, 0, 0, 0.6)'}
          style={{ width: '24px', height: '24px' }}
        />
        {notServicableMessage}
      </div>
    ) : (
      <div
        className={styles.notServicableMessageContainer}
        style={{
          justifyContent: 'center',
          fontWeight: '500',
          fontSize: '1.6rem',
          color: 'rgba(0, 0, 0, 0.6)',
          marginBottom: '24px',
        }}
      >
        {tCommon('productSelectionSection.content.currentlyUnavailable')}
      </div>
    )
  ) : null;

  // Early return if store is not yet initialized
  if (!store) {
    return null;
  }

  const buildColorHref = (c: AirRingColors) => {
    const p = new URLSearchParams(searchParams?.toString() ?? '');
    p.set('color', c);
    return `?${p.toString()}`;
  };
  // No history.replaceState here: prod's swatches are plain buttons with no URL
  // write, and a URL write per colour fires GA4's history-change page_view —
  // inflating the variant arm. Deep links still work: state inits from ?color=.
  const selectColor = (c: AirRingColors) => {
    setColor(c);
  };

  const ColorSelectionSection = (
    <Section
      title={t('ring.productSelection.colorSectionTitle')}
      subTitle={t('ring.productSelection.colorSectionSubTitle')}
      childClass="color-section"
      show={true}
      disableScrollToScreen={true}
      sectionClass="color-section"
    >
      <>
        <div className="colors">
          {getAvailableAirRingColors(store).map((element, index) => {
            const tag = getRingAirColorTag(element as AirRingColors, store);

            return (
              <a
                href={buildColorHref(element as AirRingColors)}
                style={{
                  transitionDelay: `${index * 0.05}s`,
                  transitionProperty: 'opacity',
                  textDecoration: 'none',
                }}
                key={index}
                className={`gtm color-swatch-btn ${
                  element == color ? 'active' : ''
                }`}
                data-testid={`ring-color-${element}`}
                data-buttontype="ring color selector"
                data-product="Ultrahuman Ring AIR"
                onClick={(e) => {
                  e.preventDefault();
                  trackRingBuyOption(RING_BUY_GTM_EVENTS.COLOR_SELECTED, {
                    color: element,
                    previous: color ?? undefined,
                  });
                  selectColor(element as AirRingColors);
                }}
              >
                {!notServicable && tag ? <b className="tag">{tag}</b> : null}
                <CustomImage
                  width={48}
                  height={48}
                  src={RingAirColorNameImages[element].swatch as string}
                  alt={element}
                />
              </a>
            );
          })}
        </div>
        <p className="selected-color-name">
          {color ? RingAirColorNameImages[color].name : ''}
        </p>
        {/* <div className="explore-links">
            <CustomLink href="/diesel-ultrahuman-ring/buy">
              <button
                className="gtm explore-pill"
                data-buttontype="ring style selector"
                data-product="Ultrahuman Ring AIR"
              >
                Explore Diesel Ultrahuman Ring <ArrowTopRight fill="#000" />
              </button>
            </CustomLink>
            <CustomLink href="/rare/buy">
              <button
                className="gtm explore-pill"
                data-buttontype="ring style selector"
                data-product="Ultrahuman Ring AIR"
              >
                Explore Ring Rare <ArrowTopRight fill="#000" />
              </button>
            </CustomLink>
          </div> */}
      </>
    </Section>
  );

  const StackingSelectionSection = (
    <Section
      title={t('ring.productSelection.stacking.sectionTitle')}
      subTitle={t('ring.productSelection.stacking.sectionSubTitle')}
      childClass="stacking-section"
      show={!!size}
      disableScrollToScreen={true}
      sectionClass="stacking-section"
    >
      <StackingSelectionContent
        selectedStack={stackType}
        onSelectStack={setStackType}
        selectedVariant={stackVariant}
        onSelectVariant={setStackVariant}
        prices={stackingPrices}
        duoPrices={duoStackingPrices}
        originalPrices={stackingOriginalPrices}
        originalDuoPrices={duoStackingOriginalPrices}
        discountPercentage={getBlingDiscountPercentage(store)}
        currencySymbol={currencySymbol}
        isMobile={(width as number) < PHONE_MAX_WIDTH_IN_PX}
        ringColor={color ?? undefined}
        soldOutStacks={soldOutStacks}
        onOpenImages={() => {
          ModalClient.set(
            <StackingImagesModalContent selectedColor={color ?? undefined} />,
          );
          ModalClient.setCloseBtnHidden(true);
          ModalClient.setPortal(true);
          ModalClient.show();
        }}
      />
    </Section>
  );

  const SizeSelectionSection = (
    <Section
      title={t('ring.productSelection.sizingSection.title')}
      subTitle={t('ring.productSelection.sizingSection.subTitle')}
      // subText="Guessing wrong costs the planet. Use the sizing kit to get it right the first time."

      childClass="sizing-section"
      show={!!color}
      disableScrollToScreen={true}
      sectionClass="size-section"
      ref={showSizeRef}
    >
      <>
        <div className="sizing-guide-cta">
          <LearnMoreButton onClick={openSizeInfoModal}>
            {tCommon('productSelectionSection.learnMoreButton.referOurSizing')}
          </LearnMoreButton>
        </div>
        <LargePromptBtnStyledContent
          className={`sizing-kit gtm pb ${
            size == RingSizes.OPEN ? 'active' : ''
          }`}
          data-buttontype="ring size selector"
          data-testid="ring-size-open"
          data-product="Ultrahuman Ring AIR"
          onClick={() => {
            trackRingBuyOption(RING_BUY_GTM_EVENTS.SIZE_SELECTED, {
              size: 'open',
              method: 'sizing_kit',
              previous: sizeLabel(size),
            });
            setSize(RingSizes.OPEN);
            setManualSizeSelectVisible(false);
          }}
          disabled={isOpenSizeDisabled}
        >
          <div className="content-wrapper">
            <CustomImage
              src={'web_v2/ring-buy/sizing-kit-1.png'}
              alt={tCommon('productSelectionSection.customImage.alt.sizingKit')}
              width="64"
              height="64"
              loading="lazy"
              className="sizing-kit-img"
            />
            <div className="content">
              <div className="title-bar mb">
                <div className="title">
                  {/* Sizing Kit (ships in 24 hours) */}
                  {t(
                    'ring.productSelection.sizingSection.sizingKitNew.title',
                  )}{' '}
                  {/* (
                      {t('ring.productSelection.sizingSection.sizingKitNew.titleParenthesis')}
                      ) */}
                </div>
                <div className="disclaimer">
                  <div className="price">
                    {isOpenSizeDisabled
                      ? tCommon('productSelectionSection.content.unavailable')
                      : t('ring.FREE')}
                  </div>
                </div>
              </div>
              <div className="list">
                <p>
                  <Checkmark className="checkmark" fill="#000000" />
                  {t(
                    'ring.productSelection.sizingSection.sizingKitNew.bullets.a',
                  )}
                </p>
                <p>
                  <Checkmark className="checkmark" fill="#000000" />
                  {t(
                    'ring.productSelection.sizingSection.sizingKitNew.bullets.c',
                  )}
                </p>
                <p>
                  <Checkmark className="checkmark" fill="#000000" />
                  {t(
                    'ring.productSelection.sizingSection.sizingKitNew.bullets.d',
                  )}
                </p>
              </div>
            </div>
          </div>
        </LargePromptBtnStyledContent>

        {/* CONFIG: disable delivery management */}
        {/* {store === ShopifyStore.IN ? (
              <div
                className={`delivery-management-section ${
                  size == RingSizes.OPEN ? 'active' : ''
                }`}
                style={{
                  opacity:
                    RingSelectionClient.size === RingSizes.OPEN ? '1' : '0.5',
                  pointerEvents:
                    RingSelectionClient.size === RingSizes.OPEN
                      ? 'auto'
                      : 'none',
                }}
              >
                <DeliveryManagement />
              </div>
            ) : null} */}
        {/* <div className="divider">OR</div> */}
        {isOpenSizeDisabled ? null : (
          <button
            className="manual-size gtm"
            onClick={handleManualSizeSelectShow}
            data-buttontype="Ring Size Manual Show"
            data-product="Ring Size Manual Show"
          >
            {/* I know my ring size{' '} */}
            {t('ring.productSelection.sizingSection.manualSizeText')}{' '}
            <CaretUp
              fill="#000000"
              style={{
                transition: 'all 0.3s ease-in-out',
                transform: manualSizeSelectVisible
                  ? 'rotate(0deg) translateX(0px)'
                  : 'rotate(180deg) translateX(1px)',
                height: '0.8rem',
              }}
            />
          </button>
        )}
        <div
          className={`manual-size-select-container `}
          ref={sizeContainerAccordionRef}
          style={{
            height:
              isOpenSizeDisabled && sizeContainerRef.current
                ? sizeContainerRef.current.scrollHeight + 24 + 'px'
                : undefined,
          }}
        >
          <div className="" ref={sizeContainerRef}>
            {notServicable !== true && color && !replaceWarehouse ? (
              <div className="size-shipping">
                <ShippingBox />
                <p>
                  {isAeDeliveryVisible
                    ? aeDeliveryEtaCopy(aeEta.group, aeEta.windowState, t)
                    : shippingEstimate}
                </p>
              </div>
            ) : null}
            {isOpenSizeDisabled ? null : (
              <div className="size-shipping">
                <p>
                  {/* Not a 100% sure? Go for the sizing kit. Nailing the fit the
                    first time helps you and the Earth. */}
                  {t('ring.productSelection.sizingSection.manualSizeSubText')}
                </p>
              </div>
            )}
            <div className="sizes">
              {Object.values(RingSizes)
                .filter(
                  (value) =>
                    typeof value === 'number' && value !== RingSizes.OPEN,
                )
                .map((element, index) => {
                  return (
                    <button
                      style={{
                        transitionDelay: `${index * 0.05}s`,
                        transitionProperty: 'opacity',
                      }}
                      key={index}
                      className={`gtm ${size == element ? 'active' : ''}`}
                      data-buttontype="ring size selector"
                      data-product="Ultrahuman Ring AIR"
                      data-testid={`ring-size-${element}`}
                      disabled={
                        color &&
                        productMap_air_ring[color as AirRingColors]?.[
                          element as RingSizes
                        ]?.[getEngravingKey(engraving)]?.variantId[
                          store as ShopifyStore
                        ]
                          ? false
                          : true
                      }
                      onClick={() => {
                        trackRingBuyOption(RING_BUY_GTM_EVENTS.SIZE_SELECTED, {
                          size: sizeLabel(element as RingSizes),
                          method: 'numeric',
                          previous: sizeLabel(size),
                        });
                        if (isOpenSizeDisabled) {
                          handleSizeDisclaimer();
                        }
                        setSize(element as RingSizes);
                      }}
                    >
                      {element}
                    </button>
                  );
                })}
            </div>
          </div>
        </div>
      </>
    </Section>
  );

  const ChargerSelectionSection = (
    <Section
      title={t('ring.productSelection.chargerSection.title')}
      subTitle={t('ring.productSelection.chargerSection.subTitle')}
      childClass="charger-section"
      show={!!size}
      disableScrollToScreen={true}
      sectionClass="charger-section"
      ref={showChargerRef}
      openInfoModal={openVoyagerCharger}
      // hsaFsaBadge={true}
    >
      <>
        <div className="charger">
          <button
            className={`primary ${
              chargerType === RingChargerType.TRAVEL_CHARGER ? 'active' : ''
            }`}
            onClick={() => {
              setChargerType(RingChargerType.TRAVEL_CHARGER);
            }}
            disabled={!size}
          >
            <CustomImage
              src="web_v2/illustrations/voyager_charger_thumb.png/w_800"
              alt={tCommon(
                'productSelectionSection.customImage.alt.travelCharger',
              )}
              width={200}
              height={150}
              style={{ marginBottom: '1.1rem', objectFit: 'contain' }}
            />
            <span className="tag">
              {tCommon('productSelectionSection.text.new')}
            </span>
            {store === ShopifyStore.US ? (
              <div
                className="hsa-fsa-badge"
                style={{ position: 'absolute', top: '0px', right: '4px' }}
              >
                <FSAHSAComponent />
              </div>
            ) : null}
            <p className="title">
              {t('ring.productSelection.chargerSection.voyager.title')}{' '}
              {
                CurrencySymbol[
                  RingSelectionClient.defaultCurrency.toLowerCase() as Currency
                ]
              }
              {store && (
                <>{formatPriceWithComma(getTravelChargerPrice(store) ?? 0)}</>
              )}
            </p>
            <p className="sub-title">
              {t('ring.productSelection.chargerSection.voyager.subTitle')}
            </p>
          </button>

          <button
            className={`secondary ${
              RingSelectionClient.chargerType === RingChargerType.OG
                ? 'active'
                : ''
            }`}
            onClick={() => {
              setChargerType(RingChargerType.OG);
            }}
            disabled={!size}
          >
            {t('ring.productSelection.chargerSection.normal')}
          </button>
        </div>
      </>
    </Section>
  );

  const TradeInSelectionSection = showTradeIn ? (
    <Section
      title={tCommon('productSelectionSection.section.title.trade')}
      subTitle={`${tCommon(
        'productSelectionSection.text.saveUp',
      )} ${getCurrencySymbolFromString(currency)}${formatPriceWithComma(
        getMaxTradeInCredit(store as ShopifyStore, true),
      )}.`}
      childClass="trade-in-section"
      show={!!size}
      ref={showTradeInRef}
    >
      <div className="trade-in-prompt">
        <button
          className={`gtm ${tradeInDevice ? 'active' : ''}`}
          data-buttontype="ring trade-in selector"
          data-product="Ultrahuman Ring AIR"
          onClick={() => openTradeInModal('section')}
        >
          {tradeInDevice ? (
            <>
              {tCommon('productSelectionSection.text.tradeValue')}{' '}
              {CurrencySymbol[currency.toLowerCase() as Currency]}
              {formatPriceWithComma(tradeInCredit)}
              <p className="trade-in-details">
                {tCommon('productSelectionSection.text.ringModel')}{' '}
                {TRADE_IN_DEVICE_NAMES[tradeInDevice]}
                <br />
                {tCommon('productSelectionSection.text.serialNumber')}{' '}
                {tradeInSerialNumber}
              </p>
            </>
          ) : (
            tCommon('productSelectionSection.button.tradeMyRing')
          )}
        </button>

        <button
          className={`gtm ${!tradeInDevice ? 'active' : ''}`}
          data-buttontype="ring trade-in selector"
          data-product="Ultrahuman Ring AIR"
          onClick={() => removeTradeIn('section')}
        >
          {tCommon('productSelectionSection.button.donWantTrade')}
        </button>
      </div>
    </Section>
  ) : null;

  const EngravingSelectionSection = showEngravingSection ? (
    <Section
      title={t('ring.productSelection.engravingSection.title')}
      subTitle={t('ring.productSelection.engravingSection.subTitle')}
      childClass="engraving-section"
      show={!!size}
      ref={engravingRef}
    >
      <div className="engraving-prompt">
        <button
          className={`border-radius-change gtm ${engraving ? 'active' : ''}`}
          data-buttontype="ring engraving selector"
          data-product="Ultrahuman Ring AIR"
          disabled={
            size &&
            productMap_air_ring[color as AirRingColors]?.[size]?.[
              getEngravingKey(true)
            ]?.variantId[store as ShopifyStore]
              ? false
              : true
          }
          onClick={() => {
            setEngraving(true);
          }}
        >
          {/* Add Engraving */}
          {t('ring.productSelection.engravingSection.engraving.title')}
          <p className="disclaimer-engraving">
            {/* Add custom engraving for just {currencySymbol} */}
            {t(
              'ring.productSelection.engravingSection.engraving.subTitle',
            )}{' '}
            {currencySymbol}
            {formatPriceWithComma(EngravingPrice[store as ShopifyStore])}{' '}
            {t('ring.EXTRA')}
            <br />
            {/* *Engraving orders take 7 days longer to ship */}
            {t('ring.productSelection.engravingSection.engraving.highlight')}
          </p>
        </button>

        {engraving && (
          <div className="engraving-content">
            {/* <h5>Personalise your ring</h5> */}
            {/* <p className='disclaimer-engraving'>
                  Custom engrave the ring at $200 and make it an exceptionally
                  unique gift
                </p> */}
            <div className="input-btn-container">
              <input
                id="engraving-input-field"
                onChange={(e) => {
                  const input = (e.target.value as string)
                    .trimStart()
                    .trimEnd();
                  if (
                    input != '' &&
                    !/^[A-Za-z0-9!@#$%^&*()_\-+={}[\];:'"<,>.?/|\\`~]+$/.test(
                      input,
                    )
                  )
                    return;
                  setEngravingMessage(input);
                }}
                // placeholder="eg. Jon Snow"
                placeholder={t(
                  'ring.productSelection.engravingSection.engraving.placeHolder',
                )}
                type="text"
                max={8}
                maxLength={8}
                value={engravingMessage ?? ''}
                disabled={
                  size &&
                  productMap_air_ring[color as AirRingColors]?.[size]?.[
                    getEngravingKey(engraving)
                  ]?.variantId[store as ShopifyStore]
                    ? false
                    : true
                }
              />

              <div className="max-length">
                <span style={{ textAlign: 'left' }}>
                  {/* Max. 8 characters */}
                  {t(
                    'ring.productSelection.engravingSection.engraving.maxLength',
                  )}
                </span>
                <span style={{ textAlign: 'right' }}>
                  {/* (alphanumeric & some special characters supported) */}(
                  {t(
                    'ring.productSelection.engravingSection.engraving.support',
                  )}
                  )
                </span>
              </div>
            </div>
          </div>
        )}

        <button
          className={`gtm ${engraving === false ? 'active' : ''}`}
          data-buttontype="ring engraving selector"
          data-product="Ultrahuman Ring AIR"
          disabled={
            size &&
            productMap_air_ring[color as AirRingColors]?.[size]?.[
              getEngravingKey(engraving)
            ]?.variantId[store as ShopifyStore]
              ? false
              : true
          }
          onClick={() => {
            setEngraving(false);
            setEngravingMessage(null);
          }}
        >
          {/* I don&apos;t want the engraving */}
          {t('ring.productSelection.noEngraving')}
        </button>
      </div>
    </Section>
  ) : null;

  const ClueAddonSection = isClueFlow ? (
    <Section
      title={t('ring.productSelection.clueSection.title')}
      subTitle={t('ring.productSelection.clueSection.subTitle')}
      ref={powerplugRef}
      childClass="powerPlugs-section"
      show={!!size && engraving !== null}
      // subText={
      //   {t('ring.productSelection.powerPlugsSection.subText')}
      // }
    >
      <PowerPlugSubsection
        title={t('ring.CLUE_PLUS')}
        description={t('ring.productSelection.clueSection.clue.description')}
        image="web_v2/powerplugs/icons/clue.png"
      >
        <LargePromptBtnStyledContent
          className={`clue-addon gtm ${
            clueCart === 'Year1' ? 'active' : ''
          } paddingTop`}
          data-buttontype="clue addon"
          data-product="Ultrahuman Ring AIR"
          data-testid={`ring-clue-1-year`}
          onClick={() => {
            setClueCart('Year1');
          }}
          disabled={
            size &&
            engraving !== null &&
            productMap_air_ring[color as AirRingColors]?.[size]?.[
              getEngravingKey(engraving)
            ]?.variantId[store as ShopifyStore]
              ? false
              : true
          }
        >
          <div className="label">
            {t('ring.productSelection.clueSection.clue.optionA.tag')}
          </div>
          <div className="content-wrapper">
            <div className="content">
              <div className="title-bar">
                <div className="title">
                  <span>
                    <strong>
                      {t('ring.productSelection.clueSection.clue.optionA.head')}
                    </strong>
                  </span>
                </div>
                <div className="disclaimer">
                  <div className="price-display">
                    <span className="striked price">
                      {currencySymbol}
                      {formatPriceWithComma(
                        ClueShopifyMap[store as ShopifyStore]?.Year1?.price ||
                          0,
                      )}
                    </span>
                    <div className="price">
                      {currencySymbol}
                      {(() => {
                        const price =
                          ClueShopifyMap[store as ShopifyStore]?.Year1
                            ?.discountedPrice || 0;
                        const priceStr = price.toFixed(2);
                        const [whole, decimal] = priceStr.split('.');
                        const showDecimal = decimal !== '00';
                        return (
                          <>
                            {formatPriceWithComma(parseInt(whole))}
                            {showDecimal && (
                              <span
                                style={{
                                  fontSize: '1.2rem',
                                  fontWeight: '400',
                                  color: '#000',
                                  letterSpacing: '-0.48px',
                                }}
                              >
                                .{decimal}
                              </span>
                            )}
                          </>
                        );
                      })()}
                    </div>
                  </div>
                </div>
              </div>
              {store === ShopifyStore.US ? (
                <div className="hsa-fsa-badge">
                  <FSAHSAComponent />
                </div>
              ) : null}
            </div>
          </div>
        </LargePromptBtnStyledContent>

        <button
          className={`no-ultrahumanx gtm ${clueCart === false ? 'active' : ''}`}
          data-buttontype="cno-pro selection"
          data-product="Ultrahuman Ring AIR"
          data-default-option="true"
          data-crawler-recommended="true"
          aria-label={tCommon('productSelectionSection.button.ariaLabelClue')}
          onClick={() => {
            setClueCart(false);
          }}
          disabled={
            size &&
            engraving !== null &&
            productMap_air_ring[color as AirRingColors]?.[size]?.[
              getEngravingKey(engraving)
            ]?.variantId[store as ShopifyStore]
              ? false
              : true
          }
        >
          <span>
            <strong>{t('ring.productSelection.clueSection.clue.no')}</strong>
          </span>
        </button>

        <LearnMoreButton onClick={openClueModal}>
          {tCommon('productSelectionSection.learnMoreButton.learnMore')}
        </LearnMoreButton>
      </PowerPlugSubsection>
    </Section>
  ) : null;

  const respiratoryAddonContent = (
    <PowerPlugSubsection
      title={t('ring.productSelection.respiratorySection.respiratory.title')}
      description={t(
        'ring.productSelection.respiratorySection.respiratory.description',
      )}
      image="web_v2/powerplugs/icons/respiratory-3.png"
    >
      <LargePromptBtnStyledContent
        className={`respiratory-addon gtm ${
          respiratoryCart === 'Year1' ? 'active' : ''
        } paddingTop`}
        data-buttontype="respiratory addon"
        data-product="Ultrahuman Ring AIR"
        data-testid={`ring-respiratory-1-year`}
        onClick={() => {
          setRespiratoryCart('Year1');
        }}
        disabled={
          size &&
          engraving !== null &&
          productMap_air_ring[color as AirRingColors]?.[size]?.[
            getEngravingKey(engraving)
          ]?.variantId[store as ShopifyStore]
            ? false
            : true
        }
      >
        <div className="label">
          {tCommon('productSelectionSection.content.limitedOffer')}
        </div>
        <div className="content-wrapper">
          <div className="content">
            <div className="title-bar">
              <div className="title">
                <span>
                  <strong>
                    {tCommon('productSelectionSection.emphasis.yearMembership')}
                  </strong>
                </span>
              </div>
              <div className="disclaimer">
                <div className="price-display">
                  <span
                    className={`price ${isRespiratoryFlow ? 'striked' : ''}`}
                  >
                    {currencySymbol}
                    {formatPriceWithComma(
                      RespiratoryShopifyMap[store as ShopifyStore]?.Year1
                        ?.price || 0,
                    )}
                  </span>
                  {isRespiratoryFlow ? (
                    <div className="price">
                      <span
                        style={{
                          fontSize: '1.6rem',
                          fontWeight: '500',
                          color: '#000',
                        }}
                      >
                        {tCommon('productSelectionSection.text.free')}
                      </span>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
            {store === ShopifyStore.US ? (
              <div className="hsa-fsa-badge">
                <FSAHSAComponent />
              </div>
            ) : null}
          </div>
        </div>
      </LargePromptBtnStyledContent>

      <button
        className={`no-ultrahumanx gtm ${
          respiratoryCart === false ? 'active' : ''
        }`}
        data-buttontype="respiratory selection"
        data-product="Ultrahuman Ring AIR"
        data-default-option="true"
        data-crawler-recommended="true"
        aria-label={tCommon(
          'productSelectionSection.button.ariaLabelRespiratory',
        )}
        onClick={() => {
          setRespiratoryCart(false);
        }}
        disabled={
          size &&
          engraving !== null &&
          productMap_air_ring[color as AirRingColors]?.[size]?.[
            getEngravingKey(engraving)
          ]?.variantId[store as ShopifyStore]
            ? false
            : true
        }
      >
        <span>
          <strong>
            {tCommon('productSelectionSection.emphasis.donWantKnow')}
          </strong>
        </span>
      </button>

      <LearnMoreButton onClick={openRespiratoryModal}>
        {tCommon('productSelectionSection.learnMoreButton.learnMore')}
      </LearnMoreButton>
    </PowerPlugSubsection>
  );

  const PowerplugsSelectionSection = (
    <Section
      title={t('ring.productSelection.powerPlugsSection.title')}
      subTitle={t('ring.productSelection.powerPlugsSection.subTitle')}
      ref={powerplugRef}
      childClass="powerPlugs-section"
      show={!!size && engraving !== null}
      // subText={
      //   {t('ring.productSelection.powerPlugsSection.subText')}
      // }
    >
      <Fragment>
        <PowerPlugSubsection
          // title={intl.formatMessage({
          //   id: 'ring.productSelection.powerPlugsSection.heartHealth.title',
          // })}
          title={
            isAfibOrCardio === 'afib'
              ? t('ring.AFIB')
              : t('ring.CARDIO_ADAPTIBILITY')
          }
          description={t(
            'ring.productSelection.powerPlugsSection.heartHealth.description',
          )}
          image="web_v2/powerplugs/icons/heart-health.png"
        >
          {country &&
          AfibCountryCodes.includes(country) &&
          hasAfibVariants(store as ShopifyStore) ? (
            <Fragment>
              {/* Heart Health */}
              <LargePromptBtnStyledContent
                className={`ultrahumanx gtm ${
                  afibCart && afibCart === 'Year1' ? 'active' : ''
                }`}
                data-buttontype="afib"
                data-product="Ultrahuman Ring AIR"
                data-testid={`ring-addon-1-year`}
                onClick={() => {
                  setAfibCart('Year1');
                }}
                disabled={
                  size &&
                  engraving !== null &&
                  productMap_air_ring[color as AirRingColors]?.[size]?.[
                    getEngravingKey(engraving)
                  ]?.variantId[store as ShopifyStore]
                    ? false
                    : true
                }
              >
                <div className="content-wrapper">
                  <div className="content">
                    <div className="title-bar">
                      <div className="title">
                        <span>
                          <strong>
                            {t(
                              'ring.productSelection.afibSection.optionA.head',
                            )}
                          </strong>
                        </span>
                      </div>
                      <div className="disclaimer">
                        <div className="price">
                          {currencySymbol}
                          {formatPriceWithComma(
                            AfibShopifyMap[store as ShopifyStore].Year1.price,
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </LargePromptBtnStyledContent>
              <LargePromptBtnStyledContent
                className={`ultrahumanx gtm ${
                  afibCart && afibCart === 'Year2' ? 'active' : ''
                } paddingTop`}
                data-buttontype="afib "
                data-product="Ultrahuman Ring AIR"
                data-testid={`ring-addon-2-year`}
                onClick={() => {
                  setAfibCart('Year2');
                }}
                disabled={
                  size &&
                  engraving !== null &&
                  productMap_air_ring[color as AirRingColors]?.[size]?.[
                    getEngravingKey(engraving)
                  ]?.variantId[store as ShopifyStore]
                    ? false
                    : true
                }
              >
                <div className="label">
                  {t('ring.productSelection.afibSection.optionB.tag')}
                </div>
                <div className="content-wrapper">
                  <div className="content">
                    <div className="title-bar">
                      <div className="title">
                        <span>
                          <strong>
                            {t(
                              'ring.productSelection.afibSection.optionB.head',
                            )}
                          </strong>
                        </span>
                        <span className="save-tag">
                          {t('ring.SAVE')}{' '}
                          {AfibShopifyMap[store as ShopifyStore].Year2.save}%
                        </span>
                      </div>
                      <div className="disclaimer">
                        <div className="price">
                          {currencySymbol}
                          {formatPriceWithComma(
                            AfibShopifyMap[store as ShopifyStore].Year2.price,
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </LargePromptBtnStyledContent>
              <button
                className={`no-ultrahumanx gtm ${
                  afibCart === false ? 'active' : ''
                }`}
                data-buttontype="uhx selection"
                data-product="Ultrahuman Ring AIR"
                data-default-option="true"
                data-crawler-recommended="true"
                aria-label={tCommon(
                  'productSelectionSection.button.ariaLabelAfib',
                )}
                onClick={() => {
                  setAfibCart(false);
                }}
                disabled={
                  size &&
                  engraving !== null &&
                  productMap_air_ring[color as AirRingColors]?.[size]?.[
                    getEngravingKey(engraving)
                  ]?.variantId[store as ShopifyStore]
                    ? false
                    : true
                }
              >
                <span>
                  <strong>{t('ring.productSelection.afibSection.no')}</strong>
                </span>
              </button>
              <LearnMoreButton onClick={openAfibModal}>
                {tCommon('productSelectionSection.learnMoreButton.learnMore')}
              </LearnMoreButton>
            </Fragment>
          ) : (
            <Fragment>
              {/* Heart Health */}
              <LargePromptBtnStyledContent
                className={`ultrahumanx gtm ${
                  cardioAdaptibilityCart && cardioAdaptibilityCart === 'Year1'
                    ? 'active'
                    : ''
                }`}
                data-buttontype="afib "
                data-product="Ultrahuman Ring AIR"
                data-testid={`ring-addon-1-year`}
                onClick={() => {
                  setCardioAdaptabilityCart('Year1');
                }}
                disabled={
                  size &&
                  engraving !== null &&
                  productMap_air_ring[color as AirRingColors]?.[size]?.[
                    getEngravingKey(engraving)
                  ]?.variantId[store as ShopifyStore]
                    ? false
                    : true
                }
              >
                <div className="content-wrapper">
                  <div className="content">
                    <div className="title-bar">
                      <div className="title">
                        <span>
                          <strong>
                            {t(
                              'ring.productSelection.cardioSection.optionA.head',
                            )}
                          </strong>
                        </span>
                      </div>
                      <div className="disclaimer">
                        <div className="price">
                          {currencySymbol}
                          {formatPriceWithComma(
                            CardioAdaptibilityShopifyMap[store as ShopifyStore]
                              ?.Year1.price,
                          )}
                        </div>
                      </div>
                    </div>
                    {store === ShopifyStore.US ? (
                      <>
                        <div className="hsa-fsa-badge">
                          <FSAHSAComponent />
                        </div>
                      </>
                    ) : null}
                  </div>
                </div>
              </LargePromptBtnStyledContent>
              <LargePromptBtnStyledContent
                className={`ultrahumanx gtm ${
                  cardioAdaptibilityCart && cardioAdaptibilityCart === 'Year2'
                    ? 'active'
                    : ''
                } paddingTop`}
                data-buttontype="afib "
                data-product="Ultrahuman Ring AIR"
                data-testid={`ring-addon-2-year`}
                onClick={() => {
                  setCardioAdaptabilityCart('Year2');
                }}
                disabled={
                  size &&
                  engraving !== null &&
                  productMap_air_ring[color as AirRingColors]?.[size]?.[
                    getEngravingKey(engraving)
                  ]?.variantId[store as ShopifyStore]
                    ? false
                    : true
                }
              >
                <div className="label">
                  {t('ring.productSelection.cardioSection.optionA.tag')}
                </div>
                <div className="content-wrapper">
                  <div className="content">
                    <div className="title-bar">
                      <div className="title">
                        <span>
                          <strong>
                            {t(
                              'ring.productSelection.cardioSection.optionB.head',
                            )}
                          </strong>
                        </span>
                        <span className="save-tag">
                          {t('ring.SAVE')}{' '}
                          {
                            CardioAdaptibilityShopifyMap[store as ShopifyStore]
                              ?.Year2.save
                          }
                          %
                        </span>
                      </div>
                      <div className="disclaimer">
                        <div className="price">
                          {currencySymbol}
                          {formatPriceWithComma(
                            CardioAdaptibilityShopifyMap[store as ShopifyStore]
                              ?.Year2.price,
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </LargePromptBtnStyledContent>
              <button
                className={`no-ultrahumanx gtm ${
                  cardioAdaptibilityCart === false ? 'active' : ''
                }`}
                data-buttontype="uhx selection"
                data-product="Ultrahuman Ring AIR"
                data-default-option="true"
                data-crawler-recommended="true"
                aria-label={tCommon(
                  'productSelectionSection.button.ariaLabelCardio',
                )}
                onClick={() => {
                  setCardioAdaptabilityCart(false);
                }}
                disabled={
                  size &&
                  engraving !== null &&
                  productMap_air_ring[color as AirRingColors]?.[size]?.[
                    getEngravingKey(engraving)
                  ]?.variantId[store as ShopifyStore]
                    ? false
                    : true
                }
              >
                <span>
                  <strong>{t('ring.productSelection.cardioSection.no')}</strong>
                </span>
              </button>
              <LearnMoreButton onClick={openCardioModal}>
                {tCommon('productSelectionSection.learnMoreButton.learnMore')}
              </LearnMoreButton>
            </Fragment>
          )}
        </PowerPlugSubsection>

        {showRespiratoryAddon ? (
          <>
            <Separator />
            {respiratoryAddonContent}
          </>
        ) : isCnoProActive && !isOvusenseFlow ? (
          <Fragment>
            <Separator />

            {/* Women's Health */}
            <PowerPlugSubsection
              title={t(getValue('ring.CNO_PRO', 'ring.CNO_PLUS'))}
              description={t(
                getValue(
                  'ring.productSelection.powerPlugsSection.womensHealth.description',
                  'ring.productSelection.powerPlugsSection.womensHealth.plusDescription',
                ),
              )}
              image="web_v2/powerplugs/icons/cno-pro.png"
            >
              <LargePromptBtnStyledContent
                className={`ultrahumanx gtm ${
                  cnoProCart && cnoProCart === 'Year1' ? 'active' : ''
                }`}
                data-buttontype="cno-pro"
                data-product="Ultrahuman Ring AIR"
                data-testid={`ring-cnopro-1-year`}
                onClick={() => {
                  setCnoProCart('Year1');
                }}
                disabled={
                  size &&
                  engraving !== null &&
                  productMap_air_ring[color as AirRingColors]?.[size]?.[
                    getEngravingKey(engraving)
                  ]?.variantId[store as ShopifyStore]
                    ? false
                    : true
                }
              >
                <div className="content-wrapper">
                  <div className="content">
                    <div className="title-bar">
                      <div className="title">
                        <span>
                          <strong>
                            {t(
                              'ring.productSelection.cnoProSection.optionA.head',
                            )}
                          </strong>
                        </span>
                        {store === ShopifyStore.US ? (
                          <div className="hsa-fsa-badge">
                            <FSAHSAComponent />
                          </div>
                        ) : null}
                      </div>
                      <div className="disclaimer">
                        <div className="price">
                          {currencySymbol}
                          {formatPriceWithComma(
                            CnoProShopifyMap[store as ShopifyStore]?.Year1
                              ?.price || 0,
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </LargePromptBtnStyledContent>
              <LargePromptBtnStyledContent
                className={`ultrahumanx gtm ${
                  cnoProCart && cnoProCart === 'Year2' ? 'active' : ''
                } ${
                  CnoProShopifyMap[store as ShopifyStore]?.Year2?.save
                    ? 'paddingTop'
                    : ''
                }`}
                data-buttontype="cno-pro"
                data-product="Ultrahuman Ring AIR"
                data-testid={`ring-cnopro-2-year`}
                onClick={() => {
                  setCnoProCart('Year2');
                }}
                disabled={
                  size &&
                  engraving !== null &&
                  productMap_air_ring[color as AirRingColors]?.[size]?.[
                    getEngravingKey(engraving)
                  ]?.variantId[store as ShopifyStore]
                    ? false
                    : true
                }
              >
                {!!CnoProShopifyMap[store as ShopifyStore]?.Year2?.save && (
                  <div className="label">
                    {t('ring.productSelection.cardioSection.optionA.tag')}
                  </div>
                )}

                <div className="content-wrapper">
                  <div className="content">
                    <div className="title-bar">
                      <div className="title">
                        <span>
                          <strong>
                            {t(
                              'ring.productSelection.cnoProSection.optionB.head',
                            )}
                          </strong>
                        </span>
                        {!!CnoProShopifyMap[store as ShopifyStore]?.Year2
                          ?.save && (
                          <span className="save-tag">
                            {t('ring.SAVE')}{' '}
                            {CnoProShopifyMap[store as ShopifyStore]?.Year2
                              ?.save || 15}
                            %
                          </span>
                        )}
                      </div>
                      <div className="disclaimer">
                        <div className="price">
                          {currencySymbol}
                          {formatPriceWithComma(
                            CnoProShopifyMap[store as ShopifyStore]?.Year2
                              ?.price || 0,
                          )}
                        </div>
                        {!!CnoProShopifyMap[store as ShopifyStore]?.Year2
                          ?.save && (
                          <div className="disclaimer-text">
                            <span>
                              {/* (That's just {currencySymbol} */}(
                              {t('ring.THATS_JUST')} {currencySymbol}
                              {formatPriceWithComma(
                                parseFloat(
                                  (
                                    CnoProShopifyMap[store as ShopifyStore]
                                      ?.Year2.price / 2
                                  ).toFixed(2),
                                ),
                              )}
                              {tCommon('productSelectionSection.text.year')}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </LargePromptBtnStyledContent>
              <button
                className={`no-ultrahumanx gtm ${
                  cnoProCart === false ? 'active' : ''
                }`}
                data-buttontype="cno-pro selection"
                data-product="Ultrahuman Ring AIR"
                data-default-option="true"
                data-crawler-recommended="true"
                aria-label={tCommon(
                  'productSelectionSection.button.ariaLabelCnoPro',
                )}
                onClick={() => {
                  setCnoProCart(false);
                }}
                disabled={
                  size &&
                  engraving !== null &&
                  productMap_air_ring[color as AirRingColors]?.[size]?.[
                    getEngravingKey(engraving)
                  ]?.variantId[store as ShopifyStore]
                    ? false
                    : true
                }
              >
                <span>
                  <strong>
                    {/* {t('ring.productSelection.cnoProSection.no')} TODD: translate */}
                    {tCommon(
                      'productSelectionSection.emphasis.donWantAdvanced',
                    )}
                  </strong>
                </span>
              </button>

              <LearnMoreButton onClick={openCnoPro}>
                {tCommon('productSelectionSection.learnMoreButton.learnMore')}
              </LearnMoreButton>
            </PowerPlugSubsection>
          </Fragment>
        ) : null}
      </Fragment>
    </Section>
  );

  const UHXSelectionSection = !uhx ? (
    <Section
      // title="Add an UltrahumanX coverage plan"
      title={t('ring.productSelection.uhxSectionNew.title')}
      // subText="Your peace of mind is precious. Get accidental damage protection and coverage for your Ring AIR."
      subTitle={t('ring.productSelection.uhxSectionNew.subTitle')}
      childClass="ultrahumanx-section"
      show={!!size && engraving !== null}
      ref={coverageRef}
      openInfoModal={openUhxInfoModal}
    >
      <div className="ultrahumanx-content">
        {showTradeIn && (UHX_BONUS[store as ShopifyStore] ?? 0) > 0 && (
          <div
            className="trade-in-uhx-bonus"
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '4px',
              padding: '12px 16px',
              background: 'rgba(0, 0, 0, 0.04)',
              borderRadius: '8px',
              marginBottom: '12px',
            }}
          >
            <UhxIcon
              style={{
                width: 12,
                height: 12,
                flexShrink: 0,
                marginTop: 3,
              }}
            />
            <span
              style={{
                fontSize: '14px',
                fontWeight: 500,
                color: '#000',
                letterSpacing: '-0.56px',
                lineHeight: 1.3,
                textAlign: 'left',
              }}
            >
              {tCommon('productSelectionSection.text.get')} {currencySymbol}
              {formatPriceWithComma(UHX_BONUS[store as ShopifyStore] ?? 0)}{' '}
              {tCommon('productSelectionSection.text.extraTradeCredit')}
            </span>
          </div>
        )}
        <LargePromptBtnStyledContent
          className={`ultrahumanx gtm ${uhxCart === 'Year1' ? 'active' : ''}`}
          data-buttontype="uhx selection 1 year"
          data-product="Ultrahuman Ring AIR"
          data-testid={`ring-uhx-1-year`}
          onClick={() => {
            trackRingBuyOption(RING_BUY_GTM_EVENTS.UHX_CHANGED, {
              plan: 'Year1',
              previous: uhxPlanOf(uhxCart),
              fromDefault: RingSelectionClient.uhxDefaultKept,
            });
            setUhxCart('Year1');
          }}
          disabled={
            size &&
            engraving !== null &&
            productMap_air_ring[color as AirRingColors]?.[size]?.[
              getEngravingKey(engraving)
            ]?.variantId[store as ShopifyStore]
              ? false
              : true
          }
        >
          <div className="content-wrapper">
            <div className="content">
              <div className="title-bar">
                <div className="title">
                  <span>
                    <strong>
                      {/* 1 Year Coverage */}
                      {t('ring.productSelection.uhxSectionNew.optionA.head')}
                    </strong>
                  </span>
                </div>
                <div className="disclaimer">
                  <div className="price">
                    {/* CONFIG: X days campaign - remove ☝🏻 and strike-through class */}
                    {currencySymbol}
                    {formatPriceWithComma(
                      UhxShopifyMap[store as ShopifyStore]?.Year1.price,
                    )}
                  </div>
                </div>
              </div>
              <Separator transparent size="sm" />
              <div className="list">
                <p>
                  <Checkmark className="checkmark" fill="#000000" />
                  {/* Accidental
                        damage protection */}
                  {t('ring.productSelection.uhxSectionNew.optionA.benefits.b')}
                </p>
                <p>
                  <Checkmark className="checkmark" fill="#000000" />
                  {/* Priority care */}
                  {t('ring.productSelection.uhxSectionNew.optionA.benefits.c')}
                </p>
              </div>
            </div>
          </div>
        </LargePromptBtnStyledContent>
        <LargePromptBtnStyledContent
          className={`ultrahumanx gtm ${
            uhxCart === 'Year2' ? 'active' : ''
          } paddingTop`}
          data-buttontype="uhx selection 2 year"
          data-product="Ultrahuman Ring AIR"
          data-testid={`ring-uhx-2-year`}
          onClick={() => {
            trackRingBuyOption(RING_BUY_GTM_EVENTS.UHX_CHANGED, {
              plan: 'Year2',
              previous: uhxPlanOf(uhxCart),
              fromDefault: RingSelectionClient.uhxDefaultKept,
            });
            setUhxCart('Year2');
          }}
          disabled={
            size &&
            engraving !== null &&
            productMap_air_ring[color as AirRingColors]?.[size]?.[
              getEngravingKey(engraving)
            ]?.variantId[store as ShopifyStore]
              ? false
              : true
          }
        >
          <div className="label">
            {t('ring.productSelection.uhxSectionNew.popular')}
          </div>
          <div className="content-wrapper">
            <div className="content">
              <div className="title-bar">
                <div className="title">
                  <span>
                    <strong>
                      {/* 2 Year Coverage */}
                      {t('ring.productSelection.uhxSectionNew.optionB.head')}
                    </strong>
                  </span>
                  <span className="save-tag">
                    {/* Save{' '} */}
                    {t('ring.SAVE')}{' '}
                    {Math.floor(
                      ((UhxShopifyMap[store as ShopifyStore]?.Year1.price -
                        UhxShopifyMap[store as ShopifyStore]?.Year2.price / 2) /
                        UhxShopifyMap[store as ShopifyStore]?.Year1.price) *
                        100,
                    )}
                    %
                  </span>
                </div>
                <div className="disclaimer">
                  <div className="price">
                    {/* CONFIG: X days campaign - remove ☝🏻 and strike-through class */}
                    {currencySymbol}
                    {formatPriceWithComma(
                      UhxShopifyMap[store as ShopifyStore]?.Year2.price,
                    )}
                  </div>
                  <div className="disclaimer-text">
                    <span>
                      {/* (That's just {currencySymbol} */}(
                      {t('ring.THATS_JUST')} {currencySymbol}
                      {formatPriceWithComma(
                        UhxShopifyMap[store as ShopifyStore]?.Year2.price / 2,
                      )}
                      {tCommon('productSelectionSection.text.year')}
                    </span>
                  </div>
                </div>
              </div>
              <Separator transparent size="sm" />
              <div className="list">
                <p>
                  <Checkmark className="checkmark" fill="#000000" />
                  {/* Includes all 1
                        Year Coverage benefits */}
                  {t('ring.productSelection.uhxSectionNew.optionB.benefits.a')}
                </p>
                <p>
                  <Checkmark className="checkmark" fill="#000000" />
                  {/* Theft and loss
                        protection */}
                  {t('ring.productSelection.uhxSectionNew.optionB.benefits.b')}
                </p>
                <p>
                  <Checkmark className="checkmark" fill="#000000" />
                  {/* Weight loss
                        insurance */}
                  {t('ring.productSelection.uhxSectionNew.optionB.benefits.c')}
                </p>
              </div>
            </div>
          </div>
        </LargePromptBtnStyledContent>
        <button
          className={`no-ultrahumanx gtm ${uhxCart === false ? 'active' : ''}`}
          data-buttontype="uhx selection"
          data-product="Ultrahuman Ring AIR"
          data-default-option="true"
          data-crawler-recommended="true"
          aria-label={tCommon('productSelectionSection.button.ariaLabel')}
          onClick={() => {
            trackRingBuyOption(RING_BUY_GTM_EVENTS.UHX_CHANGED, {
              plan: 'none',
              previous: uhxPlanOf(uhxCart),
              fromDefault: RingSelectionClient.uhxDefaultKept,
            });
            setUhxCart(false);
          }}
          disabled={
            size &&
            engraving !== null &&
            productMap_air_ring[color as AirRingColors]?.[size]?.[
              getEngravingKey(engraving)
            ]?.variantId[store as ShopifyStore]
              ? false
              : true
          }
        >
          <span>
            <strong>
              {/* No, I don't want to protect my new Ring AIR */}
              {t('ring.productSelection.noUhx')}
            </strong>
          </span>
        </button>
        {/* <div className="footer-info">
                //*Already an UltrahumanX subscriber? Log in with your
                registered email to access your benefits.
                {t('ring.productSelection.uhxSectionNew.tnc')}
              </div> */}
      </div>
    </Section>
  ) : null;
  // <Section childClass="ultrahumanx-section" show={!!size}>
  //   <div className="ultrahumanx-content">
  //     <div className={`card ultrahumanx`}>
  //       <div className="uhx-content">
  //         <div className="content">
  //           <h5>UltrahumanX subscription applied</h5>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // </Section>

  const OverviewSection =
    notServicable === true ? (
      <Fragment>{NotServicableMessage}</Fragment>
    ) : (
      <Fragment>
        {size ? (
          <Section
            childClass="cart-summary"
            show={!!size && (uhx || uhxCart !== null)}
            ref={cartSummaryRef}
          >
            <div className="card" id="order-summary-card">
              {/* <h4>Almost there. Here's your order summary.</h4> */}
              <h4>{t('ring.productSelection.cartSummary.head')}</h4>

              {effectiveDiscount.type === 'hero' ? (
                <div
                  className="disclaimer"
                  style={{
                    marginBottom: '20px',
                    textAlign: 'left',
                    display: 'flex',
                    alignItems: 'center',
                    marginTop: '-16px',
                  }}
                >
                  <InfoIcon
                    fill="#00000077"
                    style={{
                      flexShrink: '0',
                      marginRight: '8px',
                      alignSelf: 'flex-start',
                      transform: 'translateY(2px)',
                    }}
                  />
                  <p>
                    {t('ring.productSelection.cartSummary.heroDisclaimer.a')}
                    <CustomLink
                      href="/privacyPolicy"
                      target="_blank"
                      style={{
                        color: 'inherit !important',
                        textDecoration: 'underline',
                      }}
                    >
                      {t('ring.productSelection.cartSummary.heroDisclaimer.b')}
                    </CustomLink>
                    {t('ring.productSelection.cartSummary.heroDisclaimer.c')}
                  </p>
                  {/* Heroes Special Pricing Verification: By purchasing, you consent
                to provide ID or proof of eligibility if requested. We collect
                only what&apos;s needed, delete it after use, and handle your
                data per applicable privacy laws. Please review our Privacy
                Policy for details */}
                </div>
              ) : null}

              <div className="content">
                <h5>
                  {/* Ultrahuman Ring AIR  */}
                  {t('ring.contents.data.Ring')}{' '}
                  {/* {engraving ? '(with engraving)' : null} */}
                  {engraving ? `(${t('ring.contents.WITH_ENGRAVING')})` : null}
                </h5>
                {size ? (
                  <p className="size">
                    {color ? RingAirColorNameImages[color].name : ''},{' '}
                    {size === RingSizes.OPEN
                      ? // 'Sizing kit included'
                        t('ring.productSelection.cartSummary.sizingKitIn')
                      : //  ` Size ${size}`
                        t('ring.SIZE') + ` ${size}`}
                  </p>
                ) : null}
                <div className="price-breakup">
                  <p>
                    {/* Ring AIR */}
                    {t('ring.RingAIR')}{' '}
                  </p>
                  <p>
                    {currencySymbol}
                    {formatPriceWithComma(price)}
                  </p>
                </div>
                {uhxCart ? (
                  <div className="price-breakup">
                    <p>
                      {uhxCart === 'Year2'
                        ? //  'UltrahumanX - 2 Years'
                          `${t('ring.UltrahumanX')} - 2 Years`
                        : //  'UltrahumanX - 1 Year'
                          `${t('ring.UltrahumanX')} - 1 Year`}
                    </p>
                    <p>
                      {ultraHumanPrice === 0 ? (
                        <>
                          {/* FREE */}
                          {t('ring.FREE')}
                        </>
                      ) : (
                        <>
                          +{currencySymbol}
                          {formatPriceWithComma(ultraHumanPrice)}
                        </>
                      )}
                    </p>
                  </div>
                ) : null}
                {afibCart ? (
                  <div className="price-breakup">
                    <p>{t('ring.AFIB')}</p>
                    <p>
                      +{currencySymbol}
                      {formatPriceWithComma(
                        AfibShopifyMap[store as ShopifyStore][afibCart].price,
                      )}
                    </p>
                  </div>
                ) : null}
                {cardioAdaptibilityCart ? (
                  <div className="price-breakup">
                    <p>{t('ring.CARDIO_ADAPTIBILITY')}</p>
                    <p>
                      +{currencySymbol}
                      {formatPriceWithComma(
                        CardioAdaptibilityShopifyMap[store as ShopifyStore][
                          cardioAdaptibilityCart
                        ].price,
                      )}
                    </p>
                  </div>
                ) : null}
                {isClueFlow && clueCart ? (
                  <div className="price-breakup">
                    <p>{t('ring.productSelection.cartSummary.clue1Year')}</p>
                    <p>
                      {currencySymbol}
                      {formatPriceWithComma(
                        ClueShopifyMap[store as ShopifyStore]?.Year1?.price ||
                          0,
                      )}
                    </p>
                  </div>
                ) : null}
                {respiratoryCart ? (
                  <div className="price-breakup">
                    <p>
                      {tCommon(
                        'productSelectionSection.text.respiratoryHealthPowerplug',
                      )}
                    </p>
                    <p>
                      {currencySymbol}
                      {formatPriceWithComma(
                        RespiratoryShopifyMap[store as ShopifyStore]?.Year1
                          ?.price || 0,
                      )}
                    </p>
                  </div>
                ) : null}
                {cnoProCart ? (
                  <div className="price-breakup">
                    <p>
                      {cnoProCart === 'Year2'
                        ? `${t('ring.CNO_PRO')} - 2 years`
                        : `${t('ring.CNO_PRO')} - 1 year`}
                    </p>
                    <p>
                      +{currencySymbol}
                      {formatPriceWithComma(
                        CnoProShopifyMap[store as ShopifyStore][cnoProCart]
                          .price,
                      )}
                    </p>
                  </div>
                ) : null}
                {chargerType === RingChargerType.TRAVEL_CHARGER ? (
                  <div className="price-breakup">
                    <p>
                      {tCommon(
                        'productSelectionSection.text.voyagerRingCharger',
                      )}
                    </p>
                    <p>
                      +{currencySymbol}
                      {formatPriceWithComma(chargerPrice)}
                    </p>
                  </div>
                ) : null}
                {stackType && stackType !== RingStackType.NONE ? (
                  <div className="price-breakup">
                    <p>
                      {t(
                        stackType === RingStackType.SILVER_HALO
                          ? 'ring.productSelection.stacking.silverHalo.title'
                          : 'ring.productSelection.stacking.goldHalo.title',
                      )}
                      {stackVariant === 'DUO'
                        ? ` - ${t(
                            'ring.productSelection.stacking.duoRings.title',
                          )}`
                        : ` - ${t(
                            'ring.productSelection.stacking.singleRing.title',
                          )}`}
                    </p>
                    <p>
                      +{currencySymbol}
                      {formatPriceWithComma(
                        stackVariant === 'DUO'
                          ? (duoStackingPrices[stackType] ?? 0)
                          : (stackingPrices[stackType] ?? 0),
                      )}
                    </p>
                  </div>
                ) : null}
                {tradeInDevice && tradeInCredit > 0 ? (
                  <div className="price-breakup">
                    <p>
                      {tCommon(
                        'productSelectionSection.text.tradeCreditVerification',
                      )}
                    </p>
                    <p>
                      -{currencySymbol}
                      {formatPriceWithComma(tradeInCredit)}
                    </p>
                  </div>
                ) : null}
                {affiliateDiscount && effectiveDiscount.type === 'affiliate' ? (
                  <div className="price-breakup">
                    <p>
                      {/* Affiliate discount */}
                      {t('ring.productSelection.cartSummary.priceBreakup.b')}
                    </p>
                    <p>
                      -{currencySymbol}
                      {formatPriceWithComma(affiliateDiscount)}
                    </p>
                  </div>
                ) : null}
                {referral && effectiveDiscount.type === 'referral' ? (
                  <div className="price-breakup">
                    <p>
                      {/* Affiliate discount */}
                      {t('ring.productSelection.cartSummary.priceBreakup.b')}
                    </p>
                    <p>
                      -{currencySymbol}
                      {formatPriceWithComma(referral.discount)}
                    </p>
                  </div>
                ) : null}
                {effectiveDiscount.type === 'hero' ? (
                  <div className="price-breakup">
                    <p>
                      {/* Affiliate discount */}
                      {t('ring.productSelection.cartSummary.priceBreakup.c')}
                      <span style={{ display: 'block', fontSize: '1.2rem' }}>
                        {t('ring.productSelection.cartSummary.priceBreakup.d')}
                      </span>
                    </p>
                    <p>
                      -{currencySymbol}
                      {formatPriceWithComma(effectiveDiscount.amount)}
                    </p>
                  </div>
                ) : null}
                {isClueFlow && clueCart ? (
                  <div className="price-breakup">
                    <p>{t('ring.productSelection.cartSummary.clueDiscount')}</p>
                    <p>
                      -{currencySymbol}
                      {formatPriceWithComma(
                        (ClueShopifyMap[store as ShopifyStore]?.Year1?.price ||
                          0) -
                          (ClueShopifyMap[store as ShopifyStore]?.Year1
                            ?.discountedPrice || 0),
                      )}
                    </p>
                  </div>
                ) : null}
                {isRespiratoryFlow && respiratoryCart ? (
                  <div className="price-breakup">
                    <p>
                      {tCommon(
                        'productSelectionSection.text.respiratoryHealthPowerplug2',
                      )}
                    </p>
                    <p>
                      -{currencySymbol}
                      {formatPriceWithComma(
                        (RespiratoryShopifyMap[store as ShopifyStore]?.Year1
                          ?.price || 0) -
                          (RespiratoryShopifyMap[store as ShopifyStore]?.Year1
                            ?.discountedPrice || 0),
                      )}
                    </p>
                  </div>
                ) : null}
                {effectiveDiscount.type === 'birthday' ? (
                  <div className="price-breakup">
                    <p>
                      {/* Birthday discount */}
                      {tCommon('productSelectionSection.text.birthdayDiscount')}
                      {Math.round((effectiveDiscount.amount / price) * 100)}
                      %)
                    </p>
                    <p>
                      -{currencySymbol}
                      {formatPriceWithComma(effectiveDiscount.amount)}
                    </p>
                  </div>
                ) : null}
                {effectiveDiscount.type === 'ringPromo' ? (
                  <div className="price-breakup">
                    <p>
                      {ringCampaign?.title || 'Special'}{' '}
                      {tCommon('productSelectionSection.text.offerApplied')}
                    </p>
                    <p>
                      -{currencySymbol}
                      {formatPriceWithComma(effectiveDiscount.amount)}
                    </p>
                  </div>
                ) : null}
                {!(
                  !(store === ShopifyStore.GB || store === ShopifyStore.EU) &&
                  affiliateDiscount
                ) &&
                defaultOfferText &&
                defaultOfferDiscount ? (
                  <div className="price-breakup">
                    <p>
                      {/* Affiliate discount */}
                      {/* {t('ring.productSelection.cartSummary.priceBreakup.b')} */}
                      {defaultOfferText}{' '}
                      {tCommon('productSelectionSection.text.offer')}
                    </p>
                    <p>
                      -{currencySymbol}
                      {formatPriceWithComma(defaultOfferDiscount as number)}
                    </p>
                  </div>
                ) : null}
              </div>

              {size ? (
                <div className="total">
                  <div className="total-bar">
                    <h5>
                      {/* Total */}
                      {t('ring.TOTAL')}{' '}
                    </h5>{' '}
                    <p>
                      {currencySymbol}
                      {formatPriceWithComma(effectivePrice)}
                    </p>
                  </div>
                  {getShippingAndTaxDisclaimerMap(tCart)[
                    store as ShopifyStore
                  ] ? (
                    <p
                      className="taxes"
                      style={{
                        marginBottom: '4px',
                      }}
                    >
                      {
                        getShippingAndTaxDisclaimerMap(tCart)[
                          store as ShopifyStore
                        ]
                      }
                    </p>
                  ) : null}

                  {checkoutEta ? (
                    <p className="taxes shipping-estimate">{checkoutEta}</p>
                  ) : isAeDeliveryVisible ? (
                    <p className="taxes shipping-estimate">
                      {aeDeliveryEtaShortCopy(
                        aeEta.group,
                        aeEta.windowState,
                        t,
                      )}
                    </p>
                  ) : shippingEstimate ? (
                    <p className="taxes shipping-estimate">
                      {shippingEstimate}
                    </p>
                  ) : null}

                  <PrimaryButton
                    className="checkout"
                    disabled={
                      isLoading || !(!!size && (uhx || uhxCart !== null))
                    }
                    aria-busy={isLoading}
                    data-buttontype="add to cart"
                    data-product="Ultrahuman Ring AIR"
                    data-testid="ring-add-to-cart"
                    data-placement="summary"
                    data-variantId={
                      color && size && currency
                        ? productMap_air_ring[color]?.[size]?.[
                            getEngravingKey(engraving)
                          ]?.variantId[store as ShopifyStore]
                        : ''
                    }
                    onClick={handleCheckout}
                  >
                    {/* Add to cart */}
                    {isLoading ? (
                      <DotSpinner color="#000000" />
                    ) : (
                      t('ring.productSelection.cartSummary.addToCart')
                    )}
                  </PrimaryButton>

                  {/* <div className="" style={{ marginBottom: '16px' }}>
                    <HeroConsentDisclaimer align="flex-start" icon />
                  </div> */}

                  {pathname?.includes('/us/') ? (
                    <div className="hsa-fsa-disclaimer">
                      <CustomImage
                        src="web_v2/icons/hsa-fsa/hsa-fsa-icon-black.svg"
                        alt={tCommon(
                          'productSelectionSection.customImage.alt.hsaFsa',
                        )}
                        width="248"
                        height="81"
                      />
                      <span>
                        <b>
                          {tCommon('productSelectionSection.content.hsaFsa')}
                        </b>{' '}
                        {tCommon(
                          'productSelectionSection.text.eligibleSaveMore',
                        )}
                      </span>
                    </div>
                  ) : null}

                  <div className="shipping-info">
                    <p className="free-delivery">
                      {(() => {
                        if (!emiCopies) return null;
                        const emiLabel =
                          getIndiaEmiMonthLabel(airIndiaEmiBasePrice);
                        return emiLabel
                          ? `No cost EMI starting at ${emiLabel}. Free Delivery`
                          : null;
                      })()}
                    </p>
                  </div>
                </div>
              ) : null}
              {resolvedOffersData && resolvedOffersData.length > 0 && (
                <div className="payment-offers">
                  {resolvedOffersData.map((offer, index) => (
                    <Fragment key={index}>
                      {index > 0 && <div className="offer-divider" />}
                      <div className="offer-item">
                        <div className="offer-icon">
                          {offer.image?.[0] && (
                            <CustomImage
                              src={offer.image[0]}
                              alt=""
                              width="24"
                              height="24"
                            />
                          )}
                        </div>
                        <p>{offer.title}</p>
                      </div>
                    </Fragment>
                  ))}
                </div>
              )}

              {store &&
                ![
                  ShopifyStore.IN,
                  ShopifyStore.AE,
                  ShopifyStore.GB,
                  ShopifyStore.EU,
                ].includes(store as ShopifyStore) && (
                  <p className="disclaimer">
                    {/* *Please note that additional local taxes or carrier fees may
                    apply upon delivery */}
                    {t('ring.productSelection.cartSummary.benefits.disclaimer')}
                  </p>
                )}
              {/* <PlantTreesBanner /> */}
            </div>
            <VitaminAngelsBanner />
          </Section>
        ) : null}
      </Fragment>
    );

  const hasOfferContent =
    showRingAirPromoBanner ||
    effectiveDiscount.type === 'affiliate' ||
    (effectiveDiscount.type === 'referral' && !!referral) ||
    (effectiveDiscount.type === 'hero' &&
      !!heroCategoryOfferTagMap[searchParams?.get('heroCategory') as string]) ||
    (!!isClueFlow && !!country && !!store) ||
    (!!isRespiratoryFlow && !!country && !!store) ||
    (!!isOvusenseFlow && !!country && !!store && !!isCnoProActive) ||
    effectiveDiscount.type === 'birthday' ||
    effectiveDiscount.type === 'ringPromo' ||
    (!!defaultOfferText && !(affiliateDetails || referral));
  // India and AE show the offer tag directly under the price, above trade-in.
  const isIndiaStore = store === ShopifyStore.IN;
  const showOfferTagUnderPrice = isIndiaStore || isAeRegion;
  const offerContent = hasOfferContent ? (
    <div className="offerFlex">
      {effectiveDiscount.type === 'affiliate' ? (
        <p className="offerTag transparent">
          <span className=" ">
            {searchParams?.get('affiliateCode') === 'retouch' ? (
              <>
                {Number(
                  affiliateDetails?.discount_configs[
                    effectiveStoreForAffiliate as ShopifyStore
                  ]?.RING?.value,
                )}
                {tCommon('productSelectionSection.text.offApplied')}
              </>
            ) : (
              <>
                {Number(
                  affiliateDetails?.discount_configs[
                    effectiveStoreForAffiliate as ShopifyStore
                  ]?.RING?.value,
                )}
                {tCommon('productSelectionSection.text.offAppliedVia')}{' '}
                {
                  affiliateDetails?.discount_configs[
                    effectiveStoreForAffiliate as ShopifyStore
                  ]?.RING?.code
                }
                {/* work affiliate */}
                {searchParams?.get('workAffiliate')
                  ? ` ${tCommon('productSelectionSection.text.ultrahuman')}`
                  : ''}
              </>
            )}
          </span>
          <br />
        </p>
      ) : null}{' '}
      {effectiveDiscount.type === 'referral' && referral ? (
        <p className="offerTag">
          <span>
            <span className="offerApplied">{referral.discountCode}</span>{' '}
            {tCommon('productSelectionSection.text.offerApplied')}
          </span>
        </p>
      ) : null}
      {effectiveDiscount.type === 'hero' &&
      heroCategoryOfferTagMap[searchParams?.get('heroCategory') as string] ? (
        <p className="offerTag transparent">
          <span>
            {
              heroCategoryOfferTagMap[
                searchParams?.get('heroCategory') as string
              ]
            }
          </span>
        </p>
      ) : null}
      {isClueFlow && country && store ? (
        <p
          className="offerTag"
          style={{
            width: '100%',
            flexWrap: 'nowrap',
          }}
        >
          <span>
            <ClueLogo />
            {tCommon('productSelectionSection.text.includesYearClue')}{' '}
            {currencySymbol}
            {ClueShopifyMap[store as ShopifyStore].Year1.discountedPrice}{' '}
            {tCommon('productSelectionSection.text.worth')} {currencySymbol}
            {ClueShopifyMap[store as ShopifyStore].Year1.price})
          </span>
        </p>
      ) : null}
      {isRespiratoryFlow && country && store ? (
        <p
          className="offerTag"
          style={{
            width: '100%',
            flexWrap: 'nowrap',
          }}
        >
          <span>
            <RespiratoryLogo />
            {tCommon(
              'productSelectionSection.text.includesYearRespiratory',
            )}{' '}
            {currencySymbol}
            {RespiratoryShopifyMap[store as ShopifyStore].Year1.price})
          </span>
        </p>
      ) : null}
      {isOvusenseFlow && country && store && isCnoProActive ? (
        <button
          onClick={openCnoPro}
          className="offerTag"
          style={{
            width: '100%',
            flexWrap: 'nowrap',
          }}
        >
          <CustomImage
            src="web_v2/icons/cno-pro-addon-small.png"
            alt="cno-pro-addon-small"
            width="24"
            height="24"
          />
          <span>
            {/* <ClueLogo /> */}
            {tCommon('productSelectionSection.text.includesYear')}{' '}
            {getValue('Cycle & Ovulation Pro', 'Cycle & Ovulation Plus')}{' '}
            {tCommon('productSelectionSection.text.worth')} {currencySymbol}
            {CnoProShopifyMap[store as ShopifyStore].Year1.price}
            )
            <ChevronRight
              style={{
                width: 'auto',
                height: '12px',
                paddingLeft: '4px',
                flexShrink: '0',
              }}
            />
          </span>
        </button>
      ) : null}
      {effectiveDiscount.type === 'birthday' ? (
        <p className="offerTag">
          <Image
            src={BirthdayIcon}
            alt="birthday_icon"
            style={{
              borderRadius: '0',
            }}
          />
          <span>
            {/* <span className="offerApplied">Your birthday</span>{' '} */}
            {tCommon('productSelectionSection.text.birthdayDiscountApplied')}
          </span>
        </p>
      ) : null}
      {effectiveDiscount.type === 'ringPromo' ? (
        <p className="offerTag special-offer">
          <span>
            {ringCampaign?.title || 'SPECIAL'}{' '}
            {tCommon('productSelectionSection.text.offerApplied2')}
          </span>
        </p>
      ) : null}
      {showRingAirPromoBanner ? (
        <p className="offerTag promo-copy" style={{ width: '100%' }}>
          <span>
            {tCommon('productSelectionSection.text.ringAirPromoBanner')}
          </span>
        </p>
      ) : null}
      {defaultOfferText && !(affiliateDetails || referral) ? (
        <p className="offerTag">
          <span>
            <span className="offerApplied">{defaultOfferText}</span>{' '}
            {tCommon('productSelectionSection.text.offerApplied')}
          </span>
        </p>
      ) : null}
    </div>
  ) : null;

  const splitPaymentsDisplay = resolvedOffersData?.find(
    (offer) => offer.displayValue,
  )?.displayValue;

  // Lean buy flow (content/products/ring/buyFlow.ts): only colour, size,
  // trade-in, UHX and the order summary are offered.
  const isLeanBuyFlow = RingSelectionClient.isLeanBuyFlow;
  const keepPowerPlugs =
    isOvusenseFlow || searchParams?.get('flow') === 'respiratory';
  const productSections: Record<ProductSectionId, ReactNode> = {
    'color-picker': ColorSelectionSection,
    'size-select': SizeSelectionSection,
    'bling-stacking': isBlingVisible ? StackingSelectionSection : null,
    'charger-select': isLeanBuyFlow ? null : ChargerSelectionSection,
    'trade-in': TradeInSelectionSection,
    engraving: isLeanBuyFlow ? null : EngravingSelectionSection,
    // Clue stays only on its own partner link (the section already renders
    // nothing otherwise); power plugs likewise keep their explicit flows.
    'clue-addon': ClueAddonSection,
    'power-plugs':
      isLeanBuyFlow && !keepPowerPlugs ? null : PowerplugsSelectionSection,
    uhx: UHXSelectionSection,
    'order-overview': OverviewSection,
  };

  const sectionOrder = DEFAULT_SECTION_ORDER;

  return (
    <div className={cx(styles.buySection, className)}>
      <div className="buy-section title-info-content">
        {/* mobile section */}
        <div className="title-container">
          <H2 as="h1">{buySectionTitle}</H2>
        </div>
        {notServicable === true ? null : (
          <div className={styles.priceContentContainer}>
            <div className={styles.buyMetaStack}>
              {/* Price listing */}
              <div className="price-line">
                {(priceDrop > 0 ||
                  defaultStrikedPrice ||
                  effectiveDiscount.amount > 0) && (
                  <span className="strike-through">
                    {currencySymbol}
                    {formatPriceWithComma(strikeBasePrice)}
                  </span>
                )}
                <span className="current-price" data-testid="buy-headline-price">
                  {currencySymbol}
                  {formatPriceWithComma(price - effectiveDiscount.amount)}
                </span>
                {installmentPrice && installmentConfig && (
                  <span className="installment">
                    or&nbsp;&nbsp;{currencySymbol}
                    {formatPriceWithComma(installmentPrice)}/
                    {installmentConfig.label}&nbsp;
                    <span className="installment-symbol">&plusmn;</span>
                  </span>
                )}
                {showOfferTagUnderPrice && offerContent}
                {showTradeIn &&
                  (tradeInDevice ? (
                    <p className="trade-in-line trade-in-selected">
                      <span>
                        {tCommon('productSelectionSection.text.tradeValue')}{' '}
                        {CurrencySymbol[currency.toLowerCase() as Currency]}
                        {formatPriceWithComma(tradeInCredit)}
                      </span>
                      <span
                        className="trade-in-edit"
                        onClick={() => removeTradeIn('price_line')}
                        aria-hidden
                      >
                        {tCommon('productSelectionSection.text.remove')}
                      </span>
                    </p>
                  ) : (
                    <p className="trade-in-line">
                      <span className="trade-in-bold">
                        {tCommon('productSelectionSection.text.trade')}
                      </span>{' '}
                      {tCommon('productSelectionSection.text.saveUp')}{' '}
                      {CurrencySymbol[currency.toLowerCase() as Currency]}
                      {formatPriceWithComma(tradeInMaxCredit)} *{' '}
                      <span
                        className="trade-in-learn-more"
                        onClick={() => openTradeInModal('price_line')}
                        aria-hidden
                      >
                        {tCommon('productSelectionSection.text.opt')}{' '}
                        <ChevronRight
                          fill="#112BAF"
                          style={{
                            width: '11px',
                            height: '11px',
                            display: 'inline-block',
                            verticalAlign: 'middle',
                            // marginLeft: '4px',
                          }}
                        />
                      </span>
                    </p>
                  ))}
                {splitPaymentsDisplay && store !== ShopifyStore.IN && (
                  <div className="split-payments-row">
                    <div className="split-payments-content">
                      <div className="split-payments-icons" aria-hidden="true">
                        {splitPaymentsDisplay.icons.map((icon, index) => (
                          <CustomImage
                            key={`${icon}-${index}`}
                            src={icon}
                            alt=""
                            width="24"
                            height="24"
                          />
                        ))}
                      </div>
                      <span className="split-payments-text">
                        {splitPaymentsDisplay.text}
                      </span>
                    </div>
                    <button
                      className="split-payments-see-all"
                      onClick={handlePaymentOptions}
                    >
                      {tCommon('productSelectionSection.button.seeAll')}
                    </button>
                  </div>
                )}
              </div>
              <SddDeliverySlot>
                {/* AE hides the backend estimate line for now — the card's
                    window copy is the only ETA on this surface. */}
                {color &&
                (!replaceWarehouse || heroTimeline) &&
                !isAeDeliveryVisible ? (
                  <p className="shipping-estimate">
                    {replaceWarehouse && heroTimeline ? (
                      <SddHeroEstimate
                        date={heroTimeline.date}
                        pincode={heroTimeline.pincode}
                        when={heroTimeline.when}
                        time={heroTimeline.time}
                        window={heroTimeline.window}
                      />
                    ) : (
                      shippingEstimate
                    )}
                  </p>
                ) : null}

                {!isAeDeliveryVisible && SDD_NDD_BADGE_ENABLED ? (
                  <DeliveryEtaBadge sddNdd={sddNdd} />
                ) : null}
                {isAeDeliveryVisible ? <AeDeliveryEtaCard /> : null}
              </SddDeliverySlot>

              {!showOfferTagUnderPrice && offerContent}
            </div>

            {!resolvedOffersData ? (
              <p className="description">
                {/* A comfortable and sleek smart ring that tracks your sleep,
                  movement and recovery trends, nudging you to make healthier
                  choices every day. */}
                {description}
              </p>
            ) : null}

            {/* <ViewCount /> */}

            {secondaryOfferData && (
              <OffersCarousel data={secondaryOfferData} leftAligned={true} />
            )}

            {/* {secondaryOfferData && (
            <SecondaryOfferComponent data={secondaryOfferData} />
          )} */}
          </div>
        )}
      </div>

      <MobileCarouselSection className="carousel-section">
        <RingAirProductCarousel
          selectedColor={RingSelectionClient.color as AirRingColors}
          items={
            (RingSelectionClient.color
              ? RingAirCarouselData[RingSelectionClient.color]
              : RingAirCarouselData[AirRingColors.RAW_TITANIUM]) ?? []
          }
          sticky={false}
          footerItems={[
            {
              title: (
                <>
                  {/*
                      Free shipping {'\u00A0\u00A0'}•{'\u00A0\u00A0'} 30-night
                      risk free trial*
                      {'\u00A0\u00A0'}•{'\u00A0\u00A0'} Free returns
                      */}
                  {tCommon(
                    'productSelectionSection.ringAirProductCarousel.30NightRisk',
                  )}
                  {'\u00A0\u00A0'}•{'\u00A0\u00A0'}{' '}
                  {tCommon(
                    'productSelectionSection.ringAirProductCarousel.freeReturns',
                  )}
                </>
              ),
            },
          ]}
        />
      </MobileCarouselSection>

      {sectionOrder.map((id) => (
        <Fragment key={id}>{productSections[id]}</Fragment>
      ))}

      {isTradeInModalVisible && (
        <TradeInModal onClose={() => setIsTradeInModalVisible(false)} />
      )}
    </div>
  );
};
